(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-api"]) return;
  try {
    

  var cookies = document.cookie; //全てのcookieを取り出して
  var cookiesArray = cookies.split(';'); // ;で分割し配列に
  for(var c of cookiesArray){ //一つ一つ取り出して
    var cArray = c.split('='); //さらに=で分割して配列に
    if( cArray[0].match(/customer_id/)){ // 取り出したいkeyと合致したら
      var c_id = cArray[1];
    }
    if( cArray[0].match(/location/)){ // 取り出したいkeyと合致したら
      var referrer_location = cArray[1];
    }
    if( cArray[0].match(/access_token/)){ // 取り出したいkeyと合致したら
      var access_token = cArray[1];
    }
  }
  if(
    referrer_location.match(/pages\/account-register/) || 
    referrer_location.match(/pages\/mail-authcode/) || 
    referrer_location.match(/pages\/password-reset-authcode/) ||
    location.pathname.match(/account\/login/)
    ){
    referrer_location = "https://www.mikihouse.co.jp/";
  }
	/***************************************************************/

  /**
   * API接続ステージング
   * @param path 
   * @param params 
   * @param method 
   * @param redirect 
   */
  function apiController(path, params = "", method, redirect = false, cookies = false){
    return new Promise((resolve, reject) => {
      // default
      var headers = {
        "method": method,
        "credentials": "include",
        // "mode": "no-cors",
        "headers": {
          "Content-Type": "application/json"
        }
      }
      var cookies = document.cookie; //全てのcookieを取り出して
      var cookiesArray = cookies.split(';'); // ;で分割し配列に
      for(var c of cookiesArray){ //一つ一つ取り出して
        var cArray = c.split('='); //さらに=で分割して配列に
        if( cArray[0].match(/access_token/)){ // 取り出したいkeyと合致したら
          var access_token = cArray[1];
        }
      }
      if(cookies){
        headers.headers["X-Mikihouse-Crm-Access-Token"] = access_token;
      }
      // @Paramsがあるか判定
      if(params != ""){
        headers["body"] = JSON.stringify(params)
      }
      const base_url = "https://customapp.mikihouse.co.jp/prd/api/v1/frontend/customers";
      const url = base_url + path;
      // APIリクエスト
      fetch(url,headers).then(
        (response) => {
          return response.json()
        }
      ).then((res) => {
        console.log(res);
        if(res.access_token){
          document.cookie = "access_token="+res.access_token + "; path=/;";
        }
        
        if(res.redirect_url){
          // location.href = res.redirect_url;
        }
        if(res.callback_url){
          location.href = res.callback_url+'?withdrawal=true';
        }
        if(res.status_code >= 1000 && res.status_code < 2000 ){
          return resolve(res);
        } else if( path == "/tokens" && res.message == 'internal server error.'){
			document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              document.querySelector("#errorText").innerHTML = "大変申し訳ありません。エラーが発生しました。<br>ページを更新したのち再度お確かめください。";
              document.querySelector("#errorReload").style.display = 'block';
        } else {

          
          // errorClose
          switch (res.status_code) {
            case 3001:
           	  document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              if(path == "/tokens"){
                document.querySelector("#errorText").innerHTML = "このメールアドレスは会員登録されていません。";
               } else{
              document.querySelector("#errorText").innerHTML = "入力内容に誤りがあります。<br>お手数お掛けいたしますがご確認をお願いいたします。";
              }    
              document.querySelector("#errorClose").style.display = 'block';
              break;
            case 3002:
              //alert("リフレッシュトークンが無い");
               document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              document.querySelector("#errorText").innerHTML = "お手数お掛けして申し訳ありませんが再度ログインし直してください";
              document.querySelector("#errorLogout").style.display = 'block';
              break;
            case 3003:
              //alert("すでにアカウントがある");
              document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              document.querySelector("#errorText").innerHTML = "すでにこのメールアドレスでアカウントが登録されております。<br>申し訳ありませんが、別のメールアドレスでお確かめください。";
              document.querySelector("#errorClose").style.display = 'block';
              break;
            case 3004:
              document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              //alert("バウンスメールに登録されている");
              document.querySelector("#errorText").innerText = "申し訳ありません。正常にメールが送信できませんでした";
              document.querySelector("#errorClose").style.display = 'block';
            break;
            case 3005:
              //alert("リフレッシュトークンのHashが正しくない");
           	  document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              document.querySelector("#errorText").innerHTML = "お手数お掛けして申し訳ありませんが再度ログインし直してください";
              document.querySelector("#errorLogout").style.display = 'block';
              break;
            case 3006:
              //alert("配送情報が存在しない");
           	  document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              document.querySelector("#errorText").innerText = "配送情報が存在しません";
              document.querySelector("#errorClose").style.display = 'block';
              break;
            case 3007:
              //alert("パスワード変更時に、変更前と変更後のパスワードが同じ");
           	  document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              document.querySelector("#errorText").innerText = "変更前と変更後のパスワードが同じパスワードになっております。<br>変更前と変更後のパワスワードは違うパスワードをご入力ください。";
              break;
            case 3008:
              //alert("カスタマーサービスにデータが無い");
           	  document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              document.querySelector("#errorText").innerText = "会員情報がありません";
              document.querySelector("#errorClose").style.display = 'block';
            break;
            case 3009:
              //alert("カスタマーサービスにデータが無い");
           	  document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              document.querySelector("#errorText").innerHTML = "この電話番号はすでに登録されております。<br>この電話番号以外で必ずご本人様とご連絡のつく電話番号を入力してください。<br>ご連絡のつかない、またはご本人様以外の電話番号のご登録はお控えください。";
              document.querySelector("#errorClose").style.display = 'block';
            break;
            case 3010:
              //alert("カスタマーサービスにデータが無い");
           	  document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              // document.querySelector("#errorText").innerHTML = "指定のメールアドレスでの登録はできません。申し訳ありませんが、別のメールアドレスをご入力ください。";
              document.querySelector("#errorText").innerHTML = "このメールアドレスを利用したアカウントは既に退会しています。<br>申し訳ありませんが、別のメールアドレスをご入力ください";
              document.querySelector("#errorClose").style.display = 'block';
            break;
            case 4000:
              //alert("");
              break;
            case 4001:
              //alert("お客様が手入力するリクエストパラメータで必須入力なのに、値が空だったり、文字数が間違っている場合などの入力不備の場合");
           	  document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              document.querySelector("#errorText").innerHTML = "入力内容に誤りがあります。<br>お手数お掛けいたしますが入力内容をご確認ください。";
              document.querySelector("#errorClose").style.display = 'block';
              break;
            case 4002:
              //alert("呼び元のシステムで必ず指定してもらうリクエストパラメータがそもそも指定されていなかったり、アクセストークンなどのシステムで設定する値が不正な場合");
           	  document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
                                                            
              if(path.match(/regist_authenticate/) || path.match(/mail_authenticate/) || path.match(/password_authenticate/)){
               document.querySelector("#errorText").innerHTML = "認証コードの期限が切れているか誤りがある可能性があります。<br>お手数お掛けいたしますが、再度認証コード確認していただき入力していただくか、認証コードを再送信するようお願いいたします";
                document.querySelector("#errorClose").style.display = 'block';
              } else {
                document.querySelector("#errorText").innerHTML = "エラーが発生しました。<br>お手数お掛けして申し訳ありませんが再度ログインし直してください";
                document.querySelector("#errorLogout").style.display = 'block';
              }
              break;
            case 5000:
              //alert("DBへの読み取りや更新の際にエラーが発生したとき");
           	  document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              document.querySelector("#errorText").innerHTML = "大変申し訳ありません。エラーが発生しました。<br>ページを更新したのち再度お確かめください。";
              document.querySelector("#errorReload").style.display = 'block';
            break;
            case 6000:
              //alert("以下Cognitoエラー以外の、Cognitoのエラーが発生したとき。");
           	  document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              document.querySelector("#errorText").innerHTML = "大変申し訳ありません。エラーが発生しました。<br>ページを更新したのち再度お確かめください。";
              document.querySelector("#errorReload").style.display = 'block';
              break;
            case 6001:
              //alert("ユーザーネームかパスワード間違い");
           	  document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              document.querySelector("#errorText").innerText = "パスワードが間違っています。";
              document.querySelector("#errorClose").style.display = 'block';
              break;
            case 6002:
              //alert("メール認証が終わっていないユーザーがログインしようとしたとき");
           	  document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              document.querySelector("#errorText").innerHTML = "お客様はメール認証が完了していないようです。<br>メールをご確認の上、お手数お掛けいたしますがメール認証をお願いいたします。";
              document.querySelector("#errorClose").style.display = 'block';
              break;
            case 6003:
              //alert("登録しようとしているユーザー名が既に登録済みのとき");
           	  document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              document.querySelector("#errorText").innerHTML = "大変申し訳ありませんが、すでに同一名で登録されています。<br>別のユーザー名でご登録ください。";
              document.querySelector("#errorClose").style.display = 'block';
            break;
            case 6004:
              //alert("認証時に、同一ユーザー名が登録済みのとき");
           	  document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              document.querySelector("#errorText").innerHTML = "大変申し訳ありませんが、すでに同一名で登録されています。<br>別のユーザー名でご登録ください。";
              document.querySelector("#errorClose").style.display = 'block';
              break;
            case 6005:
              //alert("パスワード要件を満たしていないとき");
           	  document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              document.querySelector("#errorText").innerText = "パスワードは半角英字の小文字、半角英字の大文字、半角数字の3つを組み合わせて8文字以上、20文字以内で入力してください";
              document.querySelector("#errorClose").style.display = 'block';
              break;
            case 6006:
              //alert("認証コードが間違っている");
           	  document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              document.querySelector("#errorText").innerText = "認証コードが間違っています。再度お確かめの上ご入力ください。";
              document.querySelector("#errorClose").style.display = 'block';
              break;
            case 6007:
              //alert("認証コードが期限切れ");
           	  document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              document.querySelector("#errorText").innerHTML = "認証コードの期限が切れてしまいました。<br>お手数お掛けいたしますが、再度認証コードの発行をお願いいたします。";
              document.querySelector("#errorClose").style.display = 'block';
            break;
            case 6008:
              //alert("更新処理などの際に、対象ユーザーが存在しないとき");
           	  document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              document.querySelector("#errorText").innerText = "正常に更新されませんでした。<br>一度ログアウトし、再度お確かめください。";
              document.querySelector("#errorLogout").style.display = 'block';
              break;
            case 6009:
              //alert("認証回数やログイン試行回数が上限に達したとき");
           	  document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              document.querySelector("#errorText").innerHTML = "回数が上限に達しました。<br>お手数お掛けいたしますが、時間を空けて再度お確かめください。";
              document.querySelector("#errorClose").style.display = 'block';
              break;
            case 6010:
              //alert("Cognitoのクォータに達したとき");
           	  document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              document.querySelector("#errorText").innerText = "システム上のエラーが発生しました。";
              document.querySelector("#errorReload").style.display = 'block';
              break;
            case 6011:
              //alert("AccessToken関連のエラー。以下のAccessTokenエラー以外のエラーのとき。");
           	  document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              document.querySelector("#errorText").innerText = "お手数お掛けして申し訳ありませんが再度ログインし直してください";
              document.querySelector("#errorLogout").style.display = 'block';
            break;
            case 6012:
              //alert("トークンの形式がおかしいとき。意図的にトークンの形式を変えて送ってきている場合。");
           	  document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              document.querySelector("#errorText").innerText = "お手数お掛けして申し訳ありませんが再度ログインし直してください";
              document.querySelector("#errorLogout").style.display = 'block';
              break;
            case 6013:
              //alert("トークンが期限切れの時。");
           	  document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              document.querySelector("#errorText").innerText = "お手数お掛けして申し訳ありませんが再度ログインし直してください";
              document.querySelector("#errorLogout").style.display = 'block';
              break;
            case 6014:
              //alert("トークンが期限切れの時。");
           	  document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              document.querySelector("#errorText").innerText = "お手数お掛けして申し訳ありませんが再度ログインし直してください";
              document.querySelector("#errorLogout").style.display = 'block';
              break;
            case 9000:
              //alert("上記以外のタイミングでエラーが起こった時");
           	  document.querySelector("#loading").classList.remove("active");
              document.querySelector("#errorText").innerText = "";
              document.querySelector("#errorTextWrap").style.display = "flex";
              document.querySelector("#errorText").innerText = "システム上のエラーが発生しました。";
              document.querySelector("#errorReload").style.display = 'block';
              break;
            default:
              break;
          }
          return resolve(res);
        } 
      }).catch((error) => {
        console.error(error);
        document.querySelector("#errorText").innerText = "";
        document.querySelector("#errorTextWrap").style.display = "flex";
        document.querySelector("#errorText").innerText = "システム上のエラーが発生しました。";
        document.querySelector("#errorReload").style.display = 'block';
        return reject('失敗！')
      });
    });
  }
  /***************************************************************/
  // ログイン
  /**
  * Request
  * @param mail
  * @param callback_url
  * @param password
  * 
  * Response
  * @param access_token
  * @param crm_customer_id
  */
  function customerLogin(email,passwd){
  var path = "/tokens"
  var method = "POST";
  var params = {
    "mail": email,
    "callback_url": referrer_location, 
    "password": passwd
  }
  var result = apiController(path, params, method, true, false);
  return result;
  }
  /***************************************************************/
  // ログアウト
  /**
  * Request
  * @param access_token
  * @param callback_url
  * 
  * Response
  * @param callback_url
  */
  function customerLogout(customerId){
  var path = "/tokens/" + customerId + "?callback_url=https://official-mikihouse.myshopify.com/account/logout";
  var method = "DELETE";
  var params = "";
  var result = apiController(path, params, method, true, true);
  return result;
  }
   /***************************************************************/
  // メール登録
  /**
  * Request
  * @param mail
  * @param password
  */
   function emailRegister(email, passwd){
    var path = "/id"
    var method = "POST";
    var params = {
      "mail": email,
      "password": passwd
    }
    var result = apiController(path, params, method, false, false);
    return result;
    }
    /***************************************************************/
    // 会員登録承認
    /**
    * Request
    * @param mail
    * @param confirmation_code
    * 
    * Response
    * @param id
    */
    function certificationCode(email, confirmation_code) {
    var path = "/regist_authenticate"
    var method = "POST";
    var params = {
      "mail": email,
      "confirmation_code": confirmation_code
    }
    var result = apiController(path, params, method, false, false);
    return result;
    }
    /***************************************************************/
    // 初期会員登録
    /**
    * Request
    * @param id
    * @param first_name
    * @param last_name
    * @param first_name_kana
    * @param last_name_kana
    * @param phone
    * @param zip
    * @param prefecture
    * @param city
    * @param address1
    * @param address2
    * @param mail_magazine_flg
    * @param children
    */
    function addressRegister(crm_customer_id, firstName, lastName, firstNameKana, lastNameKana, phone, zipcode, prefecture, city, address1, address2, mail_magazine_flg, children){
      var path = "";
      var method = "POST";
      var params = {
        "id": crm_customer_id,
        "first_name": firstName,
        "last_name": lastName,
        "first_name_kana": firstNameKana,
        "last_name_kana": lastNameKana,
        "phone": phone,
        "zip": zipcode,
        "prefecture": prefecture,
        "city": city,
        "address1": address1,
        "address2": address2,
        "mail_magazine_flg": mail_magazine_flg,
        "children": children,
      }
      var result = apiController(path, params, method, false, false);
      return result;
    }
    /***************************************************************/
    // 退会
    /**
    * Request
    * @param access_token
    */
  
    function deleteCustomer(crm_customer_id) {
    var path = "/" + crm_customer_id;
    var method = "DELETE";
    var params = "";
    var result = apiController(path, params, method, true, true);
    return result;
    }
    /***************************************************************/
    // 住所取得
    /**
    * Request
    * @param id
    * @param access_token
    * 
    * Response
    * @param id
    * @param first_name
    * @param last_name
    * @param first_name_kana
    * @param last_name_kana
    * @param phone
    * @param zip
    * @param prefecture
    * @param city
    * @param address1
    * @param address2
    * @param mail_magazine_flg
    */
  
    function getAccountAddress(crm_customer_id){
      var path = "/" + crm_customer_id;
      var method = "GET";
      var params = "";
      var result = apiController(path, params, method, false, true);
      return result;
    }
    /***************************************************************/
    // 住所一覧取得
    /**
    * Request
    * @param id
    * @param access_token
    * 
    * Response
    * @param seq
    * @param first_name
    * @param last_name
    * @param first_name_kana
    * @param last_name_kana
    * @param phone
    * @param zip
    * @param prefecture
    * @param city
    * @param address1
    * @param address2
    * @param mail_magazine_flg
    */
  
    function getFullAddress(crm_customer_id ){
      var path = "/" + crm_customer_id + "/delivery_addresses";
      var method = "GET";
      var params = "";
      var result = apiController(path, params, method, false, true);
      return result;
    }
    /***************************************************************/
    // 住所更新
    /**
    * Request
    * @param id
    * @param access_token
    * @param first_name
    * @param last_name
    * @param first_name_kana
    * @param last_name_kana
    * @param phone
    * @param zip
    * @param prefecture
    * @param city
    * @param address1
    * @param address2
    * @param mail_magazine_flg
    * 
    * Response
    * @param id
    * @param first_name
    * @param last_name
    * @param first_name_kana
    * @param last_name_kana
    * @param phone
    * @param zip
    * @param prefecture
    * @param city
    * @param address1
    * @param address2
    * @param mail_magazine_flg
    */
  
    function updateAddress(crm_customer_id, firstName, lastName, firstNameKana, lastNameKana, phone, zipcode, prefecture, city, address1, address2, mail_magazine_flg){
      var path = "/" + crm_customer_id;
      var method = "PUT";
      var params = {
        "id": crm_customer_id,
        "first_name": firstName,
        "last_name": lastName,
        "first_name_kana": firstNameKana,
        "last_name_kana": lastNameKana,
        "phone": phone,
        "zip": zipcode,
        "prefecture": prefecture,
        "city": city,
        "address1": address1,
        "address2": address2,
        "mail_magazine_flg": mail_magazine_flg,
      }
      var result = apiController(path, params, method, false, true);
      return result;
    }
    /***************************************************************/
    /**
    * Request
    * @param id
    * @param seq
    * @param access_token
    * @param first_name
    * @param last_name
    * @param first_name_kana
    * @param last_name_kana
    * @param phone
    * @param zip
    * @param prefecture
    * @param city
    * @param address1
    * @param address2
    * @param mail_magazine_flg
    * 
    * Response
    * @param id
    * @param access_token
    */
    // 住所一覧更新
    function updateFullAddress(crm_customer_id, addresses){
      var path = "/" + crm_customer_id + "/delivery_addresses";
      var method = "PUT";
      var params = addresses;
  
      var result = apiController(path, params, method, false, true);
      return result;
    }
    /***************************************************************/
    // メールアドレス更新
    /**
    * Request
    * @param crm_customer_id 
    * @param old_mail 
    * @param new_mail 
    * 
    * Response
    * @param access_token
    */
    function updateEmailAddress(crm_customer_id, old_mail, new_mail){
      var path = "/" + crm_customer_id + "/mail"
      var method = "PUT";
      var params = {
        "old_mail": old_mail,
        "new_mail": new_mail
      }
      var result = apiController(path, params, method, false, true);
      return result;
    }
    /***************************************************************/
    // メールアドレス更新の承認
    function updateEmailAddressCertificationCode(crm_customer_id, new_mail, confirmation_code){
      var path = "/" + crm_customer_id + "/mail_authenticate"
      var method = "POST";
      var params = {
        "mail": new_mail,
        "confirmation_code": confirmation_code
      }
      var result = apiController(path, params, method, false, true);
      return result;
    }
    /***************************************************************/
    // パスワード更新
    /**
    * Request
    * @param crm_customer_id 
    * @param old_password 
    * @param new_password 
    * 
    * Response
    * @param access_token
    */
    function updatePasswd(crm_customer_id, old_password, new_password){
      var path = "/" + crm_customer_id + "/password"
      var method = "PUT";
      var params = {
        "old_password": old_password,
        "new_password": new_password
      }
      var result = apiController(path, params, method, false, true);
      return result;
    }
    /***************************************************************/
    // パスワード再発行
    /**
    * Request
    * @param mail 
    * @param first_name 
    * @param last_name 
    */
    function resetPassword(mail, last_name, first_name){
      var path = "/password_reset"
      var method = "POST";
      var params = {
        "mail": mail,
        "first_name": first_name,
        "last_name": last_name
      }
      var result = apiController(path, params, method, false, true);
      return result;
    }
    /***************************************************************/
    // パスワード再発行のメール認証
    function authenticatePassword(mail, confirmation_code, new_password, security_cd, system_datetime){
      var path = "/password_authenticate"
      var method = "POST";
      var params = {
        "mail": mail,
        "confirmation_code": confirmation_code,
        "new_password": new_password,
        "security_cd": security_cd,
        "system_datetime": system_datetime
      }
      var result = apiController(path, params, method, false, true);
      return result;
    }
    /***************************************************************/
    // 移行会員情報登録
    /**
    * Request
    * @param mail 
    * @param first_name 
    * @param last_name 
    * @param password 
    */
    function transitionCustomer(mail, first_name, last_name, password){
      var path = "/password_authenticate"
      var method = "POST";
      var params = {
        "mail": mail,
        "first_name": first_name,
        "last_name": last_name,
        "password": password
      }
      var result = apiController(path, params, method, false, true);
      return result;
    }
    /***************************************************************/
    // メール認証（移行会員）
    function registAuthenticateTransition(mail, confirmation_code){
      var path = "/regist_authenticate_transition"
      var method = "POST";
      var params = {
        "mail": mail,
        "confirmation_code": confirmation_code
      }
      var result = apiController(path, params, method, false, true);
      return result;
    }
    /***************************************************************/
      // 子ども情報取得
      function fnGetChildrenInfo(crm_customer_id){
        var path = "/" + crm_customer_id + '/children';
        var method = "GET";
        var params = "";
        var result = apiController(path, params, method, false, true);
        return result;
      }
    /***************************************************************/
      // 子ども情報更新
      function fnUpdateChildrenInfo(crm_customer_id, children){
        var path = "/" + crm_customer_id + '/children';
        var method = "PUT";
        var params = children;
        /**
         * @param params 
         * {
         *  children: {
         *    mail: mail address
         *    seq: 優先度
         *    last_name: 姓
         *    first_name: 名
         *    last_name_kana: セイ
         *    first_name_kana: メイ
         *    sex: 性別
         *    birthday: 生年月日
         *  }
         * }
         */
        var result = apiController(path, params, method, false, true);
        return result;
      }
    /***************************************************************/
    // ログインアクション
    /**
     * account/login
     */
    function loginAction(){
      var loginBtn = document.querySelector("#loginSubmit");
      var customerMail = document.querySelector("#CustomerEmail");
      var customerPasswd = document.querySelector("#CustomerPassword");
      loginBtn.addEventListener('click',async ()=>{
        var checkCustomerMail = await validationEmail(customerMail.value);
        var customerPasswdCheck = await varidationPassword(customerPasswd.value);
        var errorReset = document.querySelectorAll('.error');
          errorReset.forEach((e)=>{
            e.classList.remove('error');
          });
          var errorMessageReset = document.querySelectorAll('.errorMessage');
          errorMessageReset.forEach((e)=>{
            e.innerText = "";
          });
        if(!checkCustomerMail.error && !customerPasswdCheck.error){
          document.querySelector("#loading").classList.add("active");
          var login = await customerLogin(customerMail.value,customerPasswd.value);
          if(login.redirect_url) {
            location.href = login.redirect_url;
          }
          
          document.querySelector("#loading").classList.remove("active");
        } else {
          if(checkCustomerMail.error){
            document.querySelector(".errorMail").innerText = checkCustomerMail.error_message;
            customerMail.classList.add('error');
          } 
          if(customerPasswdCheck.error){
            document.querySelector(".errorPass").innerText = customerPasswdCheck.error_message;
            customerPasswd.classList.add('error');
          } 
        }
        
      });
    }
    /***************************************************************/
    //メールアドレス登録アクション
    /**
     * account/register
     */
    function registerCustomerAction(){
      var registerEmailBtn = document.querySelector("#registerEmailBtn");
      var customerEmail = document.querySelector("#customerEmail");
      var customerPassword = document.querySelector("#customerPassword");

	  var customerPassword2 = document.querySelector("#customerPassword2");

      registerEmailBtn.addEventListener('click',async function(){
        var customerEmailCheck = await validationEmail(customerEmail.value);
        var customerPasswordCheck = await varidationPassword(customerPassword.value);

		if(customerPassword.value != customerPassword2.value){
          passwordSome = {
            error: true,
            error_message: "同じパスワードを入力してください"
          };
        }else {
          passwordSome = {
            error: false
          };
        }

        var errorReset = document.querySelectorAll('.error');
        errorReset.forEach((e)=>{
          e.classList.remove('error');
        });
        var errorMessageReset = document.querySelectorAll('.errorMessage');
        errorMessageReset.forEach((e)=>{
          e.innerText = "";
        });
        if(!customerEmailCheck.error && !customerPasswordCheck.error && !passwordSome.error) {
          document.querySelector("#loading").classList.add("active");
          var result = await emailRegister(customerEmail.value, customerPassword.value);
          if(result.message == "success."){
            localStorage.setItem('registerPassword', customerPassword.value);
            localStorage.setItem('registerMailAddress', customerEmail.value);
            location.href = '/pages/mail-authcode';
          } else {
            document.querySelector("#loading").classList.remove("active");
          }
        } else {
          if(customerPasswordCheck.error){
            document.querySelector(".errorPassword").innerText = customerPasswordCheck.error_message;
            customerPassword.classList.add('error');
          } 
          if(customerEmailCheck.error){
            document.querySelector(".errorEmail").innerText = customerEmailCheck.error_message;
            customerEmail.classList.add('error');
          } 

		if(passwordSome.error){
            document.querySelector(".errorPassword2").innerText = passwordSome.error_message;
            customerPassword2.classList.add('error');
          }

        }
      });
    }
    /***************************************************************/
    //メールアドレス認証アクション
    /**
     * pages/mail-authcode
     */
    function registerCustomerAuthenticateAction(){
      var registerBtn = document.querySelector("#registerBtn");
      var RegisterFormEmail = document.querySelector("#RegisterForm-email");
      var RegisterFormAuthcode = document.querySelector("#RegisterForm-authcode");
      RegisterFormEmail.value = localStorage.getItem('registerMailAddress');
      if(!document.referrer.match(/account\/register/)){
        RegisterFormEmail.value = localStorage.getItem('upemail');
      }
      registerBtn.addEventListener('click',async function(){
        var RegisterFormEmailCheck = await validationEmail(RegisterFormEmail.value);
        var RegisterFormAuthcodeCheck = await validationAuthcode(RegisterFormAuthcode.value);
        var errorReset = document.querySelectorAll('.error');
        errorReset.forEach((e)=>{
          e.classList.remove('error');
        });
        var errorMessageReset = document.querySelectorAll('.errorMessage');
        errorMessageReset.forEach((e)=>{
          e.innerText = "";
        });
        if(!RegisterFormEmailCheck.error && !RegisterFormAuthcodeCheck.error){
          document.querySelector("#loading").classList.add("active");
          if(document.referrer.match(/account\/register/)){
            var result = await certificationCode(RegisterFormEmail.value, RegisterFormAuthcode.value);
          } else {
            var result = await updateEmailAddressCertificationCode(c_id, RegisterFormEmail.value, RegisterFormAuthcode.value);
          } 
          if(result.message == "success."){
            localStorage.setItem('c_id', result.id);
            if(document.referrer.match(/account\/register/)){
              location.href = '/pages/account-register';
            } else {
              location.href = '/pages/update-mailaddress?update=true';
            }
          } else {
            document.querySelector("#loading").classList.remove("active");
          }
        } else {
          // エラー処理
          if(RegisterFormAuthcodeCheck.error){
            document.querySelector(".errorPassAuthcode").innerText = RegisterFormAuthcodeCheck.error_message;
            RegisterFormAuthcode.classList.add('error');
          } 
          if(RegisterFormEmailCheck.error){
            document.querySelector(".errorPassEmail").innerText = RegisterFormEmailCheck.error_message;
            RegisterFormEmail.classList.add('error');
          } 
        }
      });
    }
    /***************************************************************/
    //新規会員情報登録アクション
    /**
     * pages/account-register
     */
     function registerCustomerAddressAction(){
      var registerAddressBtn = document.querySelector("#registerAddressBtn");
      var RegisterFormEmail = document.querySelector("#customerEmailProd");
      var mailMagazin = document.querySelector("#registerMailMagazin");
      var firstName = document.querySelector("#first-name");
      var lastName = document.querySelector("#last-name");
      var firstNameKana = document.querySelector("#first-name-kana");
      var lastNameKana = document.querySelector("#last-name-kana");
      var phoneNumber = document.querySelector("#phoneNumber");
      var zipCode = document.querySelector("#zipCode");
      var provinceList = document.querySelector("#province-list");
      var registerAddressCity = document.querySelector("#registerAddressCity");
      var registerAddress1 = document.querySelector("#registerAddress1");
      var registerAddress2 = document.querySelector("#registerAddress2");
      var customerEmailCheck = document.querySelector("#customerEmailCheck");
      RegisterFormEmail.value = localStorage.getItem('registerMailAddress');
      Array.from(provinceList.options).forEach((e, index) => {
        var i = index;
        var ret = ( '00' + i ).slice( -2 );
        if(i != 0){
          e.dataset.provinceNumber = ret;
        }
      });
        

      $('input[name="children-add"]').on('change',function(){
        if($(this).val() == 'Y'){
          $('#children-register-field').removeClass('hide');
          $('#baby-register-field').addClass('hide');
        } else {
          $('#baby-register-field').removeClass('hide');
          $('#children-register-field').addClass('hide');
        }
      });

      // 子供情報追加
      $('#add-baby-btn').on('click',function(){
        var birthday = $('#baby-birthday').val();
        var relation = $('#baby-relation').val();
        var sex = $('#baby-sex').val();
        var param = {
                  seq: 1,
                  last_name: "ベビー",
                  first_name: "ベビー",
                  last_name_kana: "ベビー",
                  first_name_kana: "ベビー",
                  sex: sex,
                  born_flg: "0",
                  birthday: birthday,
                  relationship: relation
        }
        switch (relation) {
          case '1':
            var relation_label = '孫';
            break;
          case '2':
            var relation_label = '姪・甥';
            break;
          case '3':
            var relation_label = '知人の子供';
            break;
          case '9':
            var relation_label = 'その他';
            break;
          default:
            var relation_label = '自分の子供';
        }
        switch (sex) {
          case '1':
            var sex_label = '女の子';
            break;
          case '9':
            var sex_label = 'その他';
            break;
          default:
            var sex_label = '男の子';
        }
        
        var kidsHTML = "<div class='kids-list'>\
        <label>ご出産予定日</label>\
        <div><div>\
          【出産予定日】"+ birthday +"<br>\
          【性別:】"+ sex_label +"\
          <input type='hidden' value='" + JSON.stringify(param) + "'>\
        </div>\
        <div><a href='#child-btn-content' class='btn btn--secondary btn--small childrenEdit'>編集</a><button type='button' class='btn btn--secondary btn--small childrenDelete'>削除</button></div>\
        </div></div>";
        var kids = document.querySelectorAll('.kids-list input')
        if(Object.keys(kids).length < 10 ){
          var today = new Date();
          $('#add-kids').removeClass('hide');
          $('#baby-register-field').addClass('hide');
          document.querySelector('#children-add-active').checked = false;
          $('#add-kids-list').append(kidsHTML);
          $('#baby-birthday').val(today.getFullYear() + '-' +today.getMonth() + 1 + '-' +today.getDate());
          var relation_reset = document.querySelector('#baby-relation');
          Array.from(relation_reset.options).forEach((op, index) => {
            if(index == 0) {
              op.selected = true;
            }
          });
          var sex_reset = document.querySelector('#baby-sex');
          Array.from(sex_reset.options).forEach((op, index) => {
            if(index == 0) {
              op.selected = true;
            }
          });
        }
      })

      
      // 子供情報追加
      $('#add-kid-btn').on('click',async function(){
        var lastname = $('#kid-lastname').val();
        var firstname = $('#kid-firstname').val();
        var lastnamekana = $('#kid-lastnamekana').val();
        var firstnamekana = $('#kid-firstnamekana').val();
        var birthday = $('#kid-birthday').val();
        var relation = $('#kid-relation').val();
        var sex = $('#kid-sex').val();
        var errorReset = document.querySelectorAll('.error');

        errorReset.forEach((e)=>{
          e.classList.remove('error');
        });
        var errorMessageReset = document.querySelectorAll('.errorMessage');
        errorMessageReset.forEach((e)=>{
          e.innerText = "";
        });
        var param = {
                  seq: 1,
                  last_name: lastname,
                  first_name: firstname,
                  last_name_kana: lastnamekana,
                  first_name_kana: firstnamekana,
                  sex: sex,
                  born_flg: "1",
                  birthday: birthday,
                  relationship: relation
        }
        switch (relation) {
          case '1':
            var relation_label = '孫';
            break;
          case '2':
            var relation_label = '姪・甥';
            break;
          case '3':
            var relation_label = '知人の子供';
            break;
          case '9':
            var relation_label = 'その他';
            break;
          default:
            var relation_label = '自分の子供';
        }
        switch (sex) {
          case '1':
            var sex_label = '女の子';
            break;
          case '9':
            var sex_label = 'その他';
            break;
          default:
            var sex_label = '男の子';
        }
        var kidsHTML = "<div class='kids-list'>\
        <label>"+ lastname + ' ' + firstname + "</label>\
        <div><div>\
          【フリガナ】: "+ lastnamekana + ' ' + firstnamekana + "<br>\
          【性別】: "+ sex_label +"<br>\
          【生年月日】: "+ birthday +"\
          <input type='hidden' value='" + JSON.stringify(param) + "'>\
        </div>\
        <div><a href='#child-btn-content' class='btn btn--secondary btn--small childrenEdit'>編集</a><button type='button' class='btn btn--secondary btn--small childrenDelete'>削除</button></div>\
        </div></div>";
        
        var checkKidFirstName = await varidationName(firstname);
        var checkKidLastName = await varidationName(lastname);
        var checkKidFirstNameKana = await varidationKanaName(firstnamekana);
        var checkKidLastNameKana = await varidationKanaName(lastnamekana);
        if(!checkKidFirstName.error && !checkKidLastName.error && !checkKidFirstNameKana.error && !checkKidLastNameKana.error){
          var kids = document.querySelectorAll('.kids-list input')
          if(Object.keys(kids).length < 10 ){
            var today = new Date();
            $('#add-kids').removeClass('hide');
            $('#add-kids-list').append(kidsHTML);
            $('#children-register-field').addClass('hide');
            document.querySelector('#baby-add-active').checked = false;
            $('#kid-lastname').val('');
            $('#kid-firstname').val('');
            $('#kid-lastnamekana').val('');
            $('#kid-firstnamekana').val('');
            $('#kid-birthday').val(today.getFullYear() + '-' +today.getMonth() + 1 + '-' +today.getDate());
            var relation_reset = document.querySelector('#kid-relation');
            Array.from(relation_reset.options).forEach((op, index) => {
              if(index == 0) {
                op.selected = true;
              }
            });
            var sex_reset = document.querySelector('#kid-sex');
            Array.from(sex_reset.options).forEach((op, index) => {
              if(index == 0) {
                op.selected = true;
              }
            });
          }
        } else {
          if(checkKidFirstName.error){
            document.querySelector(".errorKidFirstName").innerText = checkKidFirstName.error_message;
            $('#kid-firstname').addClass('error');
          }
          if(checkKidLastName.error){
            document.querySelector(".errorKidLastName").innerText = checkKidLastName.error_message;
            $('#kid-lastname').addClass('error');
          } 
          if(checkKidFirstNameKana.error){
            document.querySelector(".errorKidFirstNameKana").innerText = checkKidFirstNameKana.error_message;
            $('#kid-firstnamekana').addClass('error');
          }
          if(checkKidLastNameKana.error){
            document.querySelector(".errorKidLastNameKana").innerText = checkKidLastNameKana.error_message;
            $('#kid-lastnamekana').addClass('error');
          }
        }
      })

      
      // 子供情報変更
      $('#edit-baby-btn').on('click',function(){
        var birthday = $('#baby-birthday').val();
        var sex = $('#baby-sex').val();
        var relation = $('#baby-relation').val();
        var editform = $('#edit input');
        var child_json = JSON.parse(editform.val());
        var today = new Date();
        switch (relation) {
              case '1':
                var relation_label = '孫';
                break;
              case '2':
                var relation_label = '姪・甥';
                break;
              case '3':
                var relation_label = '知人の子供';
                break;
              case '9':
                var relation_label = 'その他';
                break;
              default:
                var relation_label = '自分の子供';
            }
            switch (sex) {
              case '1':
                var sex_label = '女の子';
                break;
              case '9':
                var sex_label = 'その他';
                break;
              default:
                var sex_label = '男の子';
            }
        child_json.birthday = birthday;
        child_json.relationship = relation;
        child_json.sex = sex;
        var edit_html = "【出産予定日】"+ birthday +"<br>\
              【性別:】"+ sex_label +"\
              <input type='hidden' value='" + JSON.stringify(child_json) + "'>";
        $('#edit > div > div:first-of-type').html(edit_html);
        $('#baby-register-field').removeClass('hide');
        $('#children-register-field').addClass('hide');
        $('#baby-register-field').addClass('hide');
        document.querySelector('#children-add-active').checked = false;
        $('#baby-birthday').val(today.getFullYear() + '-' +today.getMonth() + 1 + '-' +today.getDate());
        $('#baby-relation').val(1)
        $('#baby-sex').val(1)
        $('label[for="children-add-active"],label[for="baby-add-active"]').removeClass('edit')
        $('#child-btn-content').removeClass('edit');
        $('#edit').attr("id","");
        $('#baby-register-field,#children-register-field').removeClass('edit');
      });


      // 子供情報変更
      $('#edit-kid-btn').on('click',async function(){
        var lastname = $('#kid-lastname').val();
        var firstname = $('#kid-firstname').val();
        var lastnamekana = $('#kid-lastnamekana').val();
        var firstnamekana = $('#kid-firstnamekana').val();
        var birthday = $('#kid-birthday').val();
        var relation = $('#kid-relation').val();
        var sex = $('#kid-sex').val();
        var editform = $('#edit input');
        var child_json = JSON.parse(editform.val());
        var errorReset = document.querySelectorAll('.error');
    
        errorReset.forEach((e)=>{
          e.classList.remove('error');
        });
        var errorMessageReset = document.querySelectorAll('.errorMessage');
        errorMessageReset.forEach((e)=>{
          e.innerText = "";
        });
        switch (relation) {
          case '1':
            var relation_label = '孫';
            break;
          case '2':
            var relation_label = '姪・甥';
            break;
          case '3':
            var relation_label = '知人の子供';
            break;
          case '9':
            var relation_label = 'その他';
            break;
          default:
            var relation_label = '自分の子供';
        }
        switch (sex) {
          case '1':
            var sex_label = '女の子';
            break;
          case '9':
            var sex_label = 'その他';
            break;
          default:
            var sex_label = '男の子';
        }
        child_json.last_name = lastname;
        child_json.first_name = firstname;
        child_json.last_name_kana = lastnamekana;
        child_json.first_name_kana = firstnamekana;
        child_json.relationship = relation;
        child_json.birthday = birthday;
        child_json.sex = sex;
        var edit_label = lastname + ' ' + firstname;
        var edit_html = "【フリガナ】: "+ lastnamekana + ' ' + firstnamekana + "<br>\
          【性別】: "+ sex_label +"<br>\
          【生年月日】: "+ birthday +"\
          <input type='hidden' value='" + JSON.stringify(child_json) + "'>";
        
        var checkKidFirstName = await varidationName(firstname);
        var checkKidLastName = await varidationName(lastname);
        var checkKidFirstNameKana = await varidationKanaName(firstnamekana);
        var checkKidLastNameKana = await varidationKanaName(lastnamekana);
        if(!checkKidFirstName.error && !checkKidLastName.error && !checkKidFirstNameKana.error && !checkKidLastNameKana.error){
            var today = new Date();
            $('#edit > label').html(edit_label);
            $('#edit > div > div:first-of-type').html(edit_html);
            $('#add-kids').removeClass('hide');
            $('#children-register-field').addClass('hide');
            document.querySelector('#baby-add-active').checked = false;
            $('#kid-lastname').val('');
            $('#kid-firstname').val('');
            $('#kid-lastnamekana').val('');
            $('#kid-firstnamekana').val('');
            $('#kid-birthday').val(today.getFullYear() + '-' +today.getMonth() + 1 + '-' +today.getDate());
            $('#baby-relation').val(1)
            $('#baby-sex').val(1)
            $('label[for="children-add-active"],label[for="baby-add-active"]').removeClass('edit')
            $('#child-btn-content').removeClass('edit');
            $('#edit').attr("id","");
            $('#baby-register-field,#children-register-field').removeClass('edit');
        } else {
          if(checkKidFirstName.error){
            document.querySelector(".errorKidFirstName").innerText = checkKidFirstName.error_message;
            $('#kid-firstname').addClass('error');
          }
          if(checkKidLastName.error){
            document.querySelector(".errorKidLastName").innerText = checkKidLastName.error_message;
            $('#kid-lastname').addClass('error');
          } 
          if(checkKidFirstNameKana.error){
            document.querySelector(".errorKidFirstNameKana").innerText = checkKidFirstNameKana.error_message;
            $('#kid-firstnamekana').addClass('error');
          }
          if(checkKidLastNameKana.error){
            document.querySelector(".errorKidLastNameKana").innerText = checkKidLastNameKana.error_message;
            $('#kid-lastnamekana').addClass('error');
          }
        }
      })



      registerAddressBtn.addEventListener('click',async function(){
        // var checkEmail = await validationEmail(RegisterFormEmail.value);
        // var collationEmail = await checkCollationEmail(RegisterFormEmail.value, customerEmailCheck.value);
        var checkFirstName = await varidationName(firstName.value);
        var checkLastName = await varidationName(lastName.value);
        var checkFirstNameKana = await varidationKanaName(firstNameKana.value);
        var checkLastNameKana = await varidationKanaName(lastNameKana.value);
        var checkZip = await validationZipcode(zipCode.value);
        var checkPhone = await validationPhone(phoneNumber.value);
        var checkAddressCity = await validationCity(registerAddressCity.value, true);
        var checkAddress1 = await validationCity(registerAddress1.value, true);
        var checkAddress2 = await validationCity(registerAddress2.value);
        var errorReset = document.querySelectorAll('.error');
        errorReset.forEach((e)=>{
          e.classList.remove('error');
        });
        var errorMessageReset = document.querySelectorAll('.errorMessage');
        errorMessageReset.forEach((e)=>{
          e.innerText = "";
        });

        var kidsList = document.querySelectorAll('.kids-list input')
        var children = [];
        kidsList.forEach((e, index) => {
          var val = JSON.parse(e.value)
          val.seq = index + 1
          children.push(val)
        });
                
        // バリデーションOKの確認
        if(!checkFirstName.error && !checkLastName.error && !checkFirstNameKana.error && !checkLastNameKana.error && !checkPhone.error && !checkZip.error && !checkAddressCity.error && !checkAddress1.error && !checkAddress2.error){
          var province = "";
          var mailMaga = "";
          var customerId = localStorage.getItem("c_id");

          Array.from(provinceList.options).forEach((e, index) => {
            if(e.selected){
              province = e;
            }
          });
          if(mailMagazin.checked){
            mailMaga = "0";
          } else {
            mailMaga = "1"
          }
          // 一時退避 
          /***********************************************************/
          document.querySelector("#loading").classList.add("active");
          var result = await addressRegister(
            customerId, 
            firstName.value, 
            lastName.value, 
            firstNameKana.value, 
            lastNameKana.value, 
            phoneNumber.value, 
            zipCode.value, 
            province.dataset.provinceNumber, 
            registerAddressCity.value, 
            registerAddress1.value, 
            registerAddress2.value, 
            mailMaga,
            children
          );
          
          if(result.message == "success."){
            var mailAdd = localStorage.getItem('registerMailAddress');
            var passwd = localStorage.getItem('registerPassword');
            var loginAction = await customerLogin(mailAdd,passwd);
            if(!loginAction.access_token){
              var loginAction = await customerLogin(mailAdd,passwd);
            } else {
              if(result.message == "success."){
                localStorage.removeItem('registerMail');
                localStorage.removeItem('confirmationMail');
                localStorage.removeItem('registerMailAddress');
                localStorage.removeItem('registerPassword');
                location.href = loginAction.redirect_url;
              }
            }
          } else {
            var errors = result.errors;
            if(errors.phone){
              document.querySelector(".errorPhoneNumber").innerText = "半角数字とハイフン(-)を抜いて10桁または11桁で存在する電話番号を入力してください";
              phoneNumber.classList.add('error');
            }
            document.querySelector("#loading").classList.remove("active");
          }
          /***********************************************************/
        } else {


          if(checkFirstName.error){
            document.querySelector(".errorFirstName").innerText = checkFirstName.error_message;
            firstName.classList.add('error');
          }
          if(checkLastName.error){
            document.querySelector(".errorLastName").innerText = checkLastName.error_message;
            lastName.classList.add('error');
          } 
          if(checkFirstNameKana.error){
            document.querySelector(".errorFirstNameKana").innerText = checkFirstNameKana.error_message;
            firstNameKana.classList.add('error');
          }
          if(checkLastNameKana.error){
            document.querySelector(".errorLastNameKana").innerText = checkLastNameKana.error_message;
            lastNameKana.classList.add('error');
          }
          if(checkPhone.error){
            document.querySelector(".errorPhoneNumber").innerText = checkPhone.error_message;
            phoneNumber.classList.add('error');
          }
          if(checkZip.error){
            document.querySelector(".errorzipCode").innerText = checkZip.error_message;
            zipCode.classList.add('error');
          }
          if(checkAddressCity.error){
            document.querySelector(".errorRegisterAddressCity").innerText = checkAddressCity.error_message;
            registerAddressCity.classList.add('error');
          } 
          if(checkAddress1.error){
            document.querySelector(".errorRegisterAddress1").innerText = checkAddress1.error_message;
            registerAddress1.classList.add('error');
          }
          if(checkAddress2.error){
            document.querySelector(".errorRegisterAddress2").innerText = checkAddress2.error_message;
            registerAddress2.classList.add('error');
          }
          // alert('バリデーションエラー' + test);
        }
      });
    }
    /***************************************************************/
    //会員情報
    async function getAddressAction(c_id){
      var province = "";
      var updateAccountAddress = await getAccountAddress(c_id);
      var getAccountFullAddress = await getFullAddress(c_id);
      let array = ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県'];
      // View
  
      var customerUpdateBtn = document.querySelector("#customerInfoUpdate");
      var customerUpdate = document.querySelector("#customerUpdate");
      // Form
      
      var updateCustomerLastName = document.querySelector("#updateCustomerLastName");
      var updateCustomerFirstName = document.querySelector("#updateCustomerFirstName");
      var updateCustomerLastNameKana = document.querySelector("#updateCustomerLastNameKana");
      var updateCustomerFirstNameKana = document.querySelector("#updateCustomerFirstNameKana");
      var updateCustomerPhone = document.querySelector("#updateCustomerPhone");
      var updateCustomerZip = document.querySelector("#updateCustomerZip");
      var updateCustomerPrefecture = document.querySelector("#updateCustomerPrefecture");
      var updateCustomerCity = document.querySelector("#updateCustomerCity");
      var updateCustomerAddress1 = document.querySelector("#updateCustomerAddress1");
      var updateCustomerAddress2 = document.querySelector("#updateCustomerAddress2");
      var updateActive = document.querySelector("#updateActive");
  
      Array.from(updateCustomerPrefecture.options).forEach((e, index) => {
        var i = index + 1;
        var ret = ( '00' + i ).slice( -2 );
        e.dataset.provinceNumber = ret;
      });
      customerUpdateBtn.addEventListener('click',function(){
        customerUpdate.classList.toggle('active');
      });
      updateActive.addEventListener('click',async function(){
        var checkFirstName = await varidationName(updateCustomerFirstName.value);
        var checkLastName = await varidationName(updateCustomerLastName.value);
        var checkFirstNameKana = await varidationKanaName(updateCustomerFirstNameKana.value);
        var checkLastNameKana = await varidationKanaName(updateCustomerLastNameKana.value);
        var checkZip = await validationZipcode(updateCustomerZip.value);
        var checkPhone = await validationPhone(updateCustomerPhone.value);
        var checkAddressCity = await validationCity(updateCustomerCity.value, true);
        var checkAddress1 = await validationCity(updateCustomerAddress1.value, true);
        var checkAddress2 = await validationCity(updateCustomerAddress2.value);
        Array.from(updateCustomerPrefecture.options).forEach((e, index) => {
          if(e.selected){
            province = e;
          }
        });
        // 更新
        var errorReset = document.querySelectorAll('.error');
          errorReset.forEach((e)=>{
            e.classList.remove('error');
          });
          var errorMessageReset = document.querySelectorAll('.errorMessage');
          errorMessageReset.forEach((e)=>{
            e.innerText = "";
          });
          // 更新
        if(!checkFirstName.error && !checkLastName.error && !checkFirstNameKana.error && !checkLastNameKana.error && !checkPhone.error && !checkZip.error && !checkAddressCity.error && !checkAddress1.error && !checkAddress2.error){
          document.querySelector("#loading").classList.add("active");
          var result = await updateAddress(
            c_id, 
            updateCustomerFirstName.value, 
            updateCustomerLastName.value, 
            updateCustomerFirstNameKana.value, 
            updateCustomerLastNameKana.value, 
            updateCustomerPhone.value, 
            updateCustomerZip.value, 
            province.dataset.provinceNumber, 
            updateCustomerCity.value, 
            updateCustomerAddress1.value, 
            updateCustomerAddress2.value, 
            updateAccountAddress.mail_magazine_flg
          );
          
         
          
          if(result.message == "success."){
           // location.reload(true);
             //location.href = "?account_update=true";
             var customerInfoUpdateBtn = document.querySelector('#customerInfoUpdateBtn');
             customerInfoUpdateBtn.click();
          } else {
var errors = result.errors;
            if(errors.phone){
              document.querySelector(".errorPhoneNumber").innerText = "半角数字とハイフン(-)を抜いて10桁または11桁で存在する電話番号を入力してください";
              updateCustomerPhone.classList.add('error');
            }
            document.querySelector("#loading").classList.remove("active");
          }
        } else {
          varidationMessage(
            checkFirstName,
            checkLastName,
            checkFirstNameKana,
            checkLastNameKana,
            checkPhone,
            checkZip,
            checkAddressCity,
            checkAddress1,
            checkAddress2
          );
        }
        
      }); 
    }
    /***************************************************************/
    //住所一覧情報
    async function getFullAddressAction(getAccountFullAddress){
      // var getAccountFullAddress = await getFullAddress(c_id);
      // var getAddress = await getAccountAddress(c_id);

      var AddressLastNameNew = document.querySelector('#AddressLastNameNew');
      var AddressFirstNameNew = document.querySelector('#AddressFirstNameNew');
      var AddressLastNameKanaNew = document.querySelector('#AddressLastNameKanaNew');
      var AddressFirstNameKanaNew = document.querySelector('#AddressFirstNameKanaNew');
      var AddressPhoneNew = document.querySelector('#AddressPhoneNew');
      var AddressZipNew = document.querySelector('#AddressZipNew');
      var AddressProvinceNew = document.querySelector('#AddressProvincesNew');
      var AddressCityNew = document.querySelector('#AddressCityNew');
      var AddressAddress1New = document.querySelector('#AddressAddress1New');
      var AddressAddress2New = document.querySelector('#AddressAddress2New');
      // var address_default_address_new = document.querySelector('#address_default_address_new');
      var AddressNewBtn = document.querySelector('#AddressNewBtn');
      Array.from(AddressProvinceNew.options).forEach((e, index) => {
        var i = index + 1;
        var ret = ( '00' + i ).slice( -2 );
        e.dataset.provinceNumber = ret;
      });
      AddressNewBtn.addEventListener('click',async function(){
       
        Array.from(AddressProvinceNew.options).forEach((e, index) => {
          if(e.selected){
            province = e;
          }
        });

          var checkFirstName = await varidationName(AddressFirstNameNew.value);
          var checkLastName = await varidationName(AddressLastNameNew.value);
          var checkFirstNameKana = await varidationKanaName(AddressFirstNameKanaNew.value);
          var checkLastNameKana = await varidationKanaName(AddressLastNameKanaNew.value);
          var checkZip = await validationZipcode(AddressZipNew.value);
          var checkPhone = await validationPhone(AddressPhoneNew.value);
          var checkAddressCity = await validationCity(AddressCityNew.value,true);
          var checkAddress1 = await validationCity(AddressAddress1New.value,true);
          var checkAddress2 = await validationCity(AddressAddress2New.value);
          if(!checkFirstName.error && !checkLastName.error && !checkFirstNameKana.error && !checkLastNameKana.error && !checkPhone.error && !checkZip.error && !checkAddressCity.error && !checkAddress1.error && !checkAddress2.error){
            document.querySelector("#loading").classList.add("active");
            var addresNewPush = [{
              "seq": getAccountFullAddress.addresses.length + 1,
              "first_name": AddressFirstNameNew.value,
              "last_name": AddressLastNameNew.value,
              "first_name_kana": AddressFirstNameKanaNew.value,
              "last_name_kana": AddressLastNameKanaNew.value,
              "phone": AddressPhoneNew.value,
              "zip": AddressZipNew.value,
              "prefecture": province.dataset.provinceNumber,
              "city": AddressCityNew.value,
              "address1": AddressAddress1New.value,
              "address2": AddressAddress2New.value
            }];
            var pushAddresses = getAccountFullAddress.addresses.concat(addresNewPush); 
            

            var array = {
              "addresses": pushAddresses
            }
            
            var result = await updateFullAddress(c_id, array);
            if(result.message == "success."){
              location.href = "?account_update=true";
            } else {
			      var errors = result.errors.addresses;

             if(errors){
              document.querySelector(".errorPhoneNumberNew").innerText = "半角数字とハイフン(-)を抜いて10桁または11桁で存在する電話番号を入力してください";
              AddressPhoneNew.classList.add('error');
            }
              
              document.querySelector("#loading").classList.remove("active");
            }
          } else {
            var errorReset = document.querySelectorAll('.error');
                errorReset.forEach((e)=>{
                  e.classList.remove('error');
                });
                var errorMessageReset = document.querySelectorAll('.errorMessage');
                errorMessageReset.forEach((e)=>{
                  e.innerText = "";
                });
                if(checkFirstName.error){
                  document.querySelector(".errorFirstNameNew").innerText = checkFirstName.error_message;
                  AddressFirstNameNew.classList.add('error');
                } 
                if(checkLastName.error){
                  document.querySelector(".errorLastNameNew").innerText = checkLastName.error_message;
                  AddressLastNameNew.classList.add('error');
                }
                if(checkFirstNameKana.error){
                  document.querySelector(".errorFirstNameKanaNew").innerText = checkFirstNameKana.error_message;
                  AddressFirstNameKanaNew.classList.add('error');
                }
                if(checkLastNameKana.error){
                  document.querySelector(".errorLastNameKanaNew").innerText = checkLastNameKana.error_message;
                  AddressLastNameKanaNew.classList.add('error');
                }
                if(checkPhone.error){
                  document.querySelector(".errorPhoneNumberNew").innerText = checkPhone.error_message;
                  AddressPhoneNew.classList.add('error');
                }
                if(checkZip.error){
                  document.querySelector(".errorzipCodeNew").innerText = checkZip.error_message;
                  AddressZipNew.classList.add('error');
                }
                if(checkAddressCity.error){
                  document.querySelector(".errorRegisterAddressCityNew").innerText = checkAddressCity.error_message;
                  AddressCityNew.classList.add('error');
                } 
                if(checkAddress1.error){
                  document.querySelector(".errorRegisterAddress1New").innerText = checkAddress1.error_message;
                  AddressAddress1New.classList.add('error');
                }
                if(checkAddress2.error){
                  document.querySelector(".errorRegisterAddress2New").innerText = checkAddress2.error_message;
                  AddressAddress2New.classList.add('error');
                }
          }     
      });
    }
    /***************************************************************/
    /**
     * 更新
     * 
     */
     async function ShippingAddress(getAccountFullAddress){
      // var getAccountFullAddress = await getFullAddress(c_id);
      var addresses = getAccountFullAddress.addresses;
      addresses.sort(function(a,b){
        if(a.seq < b.seq) return -1;
        if(a.seq > b.seq) return 1;
        return 0;
      });

  
      var UpdateShippingAddresses = document.querySelectorAll('.UpdateShippingAddress');
      UpdateShippingAddresses.forEach(function(e){
        var formId = e.dataset.formId;
        var AddressLastName = document.querySelector('#AddressLastName_' + formId);
        var AddressFirstName = document.querySelector('#AddressFirstName_' + formId);
        var AddressFirstNameKana = document.querySelector('#AddressFirstNameKana_' + formId);
        var AddressLastNameKana = document.querySelector('#AddressLastNameKana_' + formId);
        var AddressPhone = document.querySelector('#AddressPhone_' + formId);
        var AddressZip = document.querySelector('#AddressZip_' + formId);
        var AddressProvince = document.querySelector('#AddressProvinces_' + formId);
        var AddressCity = document.querySelector('#AddressCity_' + formId);
        var AddressAddress1 = document.querySelector('#AddressAddress1_' + formId);
        var AddressAddress2 = document.querySelector('#AddressAddress2_' + formId);
        Array.from(AddressProvince.options).forEach((el, ind) => {
          var i = ind + 1;
          var ret = ( '00' + i ).slice( -2 );
          el.dataset.provinceNumber = ret;
        });
        Array.from(AddressProvince.options).forEach((elme, idx) => {
          if(elme.selected){
            province = elme;
          }
        });
        addresses.forEach(function(address){
          if(AddressLastName.value == address.last_name && 
            AddressFirstName.value == address.first_name && 
            AddressFirstNameKana.value == address.first_name_kana &&
            AddressLastNameKana.value == address.last_name_kana && 
            AddressPhone.value == address.phone && 
            AddressZip.value == address.zip && 
            province.dataset.provinceNumber == address.prefecture && 
            AddressCity.value == address.city && 
            AddressAddress1.value == address.address1  ){
              e.dataset.seq = address.seq;
              var removeBtn = document.querySelector("#AddressDeleteBtn_" + formId);
              var defaultBtn = document.querySelector("#AddressDefaultBtn_" + formId);
              if(removeBtn){
                removeBtn.dataset.seq = address.seq;
              }
              if(defaultBtn){
                defaultBtn.dataset.seq = address.seq;
              }
          }
        });
        e.addEventListener('click',async function(evt){
          
          for(i=0;i<addresses.length;i++){
            
            if(addresses[i].seq == e.dataset.seq){
              var idx = e.dataset.formId;
              var updateShippingLastName = document.querySelector('#AddressLastName_' + idx);
              var updateShippingFirstName = document.querySelector('#AddressFirstName_' + idx);
              var updateShippingFirstNameKana = document.querySelector('#AddressFirstNameKana_' + idx);
              var updateShippingLastNameKana = document.querySelector('#AddressLastNameKana_' + idx);
              var updateShippingPhone = document.querySelector('#AddressPhone_' + idx);
              var updateShippingZip = document.querySelector('#AddressZip_' + idx);
              var updateShippingProvince = document.querySelector('#AddressProvinces_' + idx);
              var updateShippingCity = document.querySelector('#AddressCity_' + idx);
              var updateShippingAddress1 = document.querySelector('#AddressAddress1_' + idx);
              var updateShippingAddress2 = document.querySelector('#AddressAddress2_' + idx);
              Array.from(updateShippingProvince.options).forEach((elme, idx) => {
                if(elme.selected){
                  upProvince = elme;
                }
              });
              var checkFirstName = await varidationName(updateShippingFirstName.value);
              var checkLastName = await varidationName(updateShippingLastName.value);
              var checkFirstNameKana = await varidationKanaName(updateShippingFirstNameKana.value);
              var checkLastNameKana = await varidationKanaName(updateShippingLastNameKana.value);
              var checkZip = await validationZipcode(updateShippingZip.value);
              var checkPhone = await validationPhone(updateShippingPhone.value);
              var checkAddressCity = await validationCity(updateShippingCity.value, true);
              var checkAddress1 = await validationCity(updateShippingAddress1.value, true);
              var checkAddress2 = await validationCity(updateShippingAddress2.value);
              if(!checkFirstName.error && !checkLastName.error && !checkFirstNameKana.error && !checkLastNameKana.error && !checkPhone.error && !checkZip.error && !checkAddressCity.error && !checkAddress1.error && !checkAddress2.error){
                document.querySelector("#loading").classList.add("active");
                addresses[i].last_name = updateShippingLastName.value;
                addresses[i].first_name = updateShippingFirstName.value;
                addresses[i].last_name_kana = updateShippingLastNameKana.value;
                addresses[i].first_name_kana = updateShippingFirstNameKana.value;
                addresses[i].phone = updateShippingPhone.value;
                addresses[i].zip = updateShippingZip.value;
                addresses[i].prefecture = upProvince.dataset.provinceNumber;
                addresses[i].city = updateShippingCity.value;
                addresses[i].address1 = updateShippingAddress1.value;
                addresses[i].address2 = updateShippingAddress2.value;
                addresses[i].seq = Number(e.dataset.seq);
                
                var array = {
                  "addresses": addresses
                }
                var result = await updateFullAddress(c_id, array);
                if(result.message == "success."){
                  // location.reload(true);
                  location.href = "?account_update=true";
                } else {
var errors = result.errors.addresses;
               if(errors){
              document.querySelector(".errorPhoneNumber_"+idx).innerText = "半角数字とハイフン(-)を抜いて10桁または11桁で存在する電話番号を入力してください";
              updateShippingPhone.classList.add('error');
            }
                  document.querySelector("#loading").classList.remove("active");
                }
              } else {
                var errorReset = document.querySelectorAll('.error');
                errorReset.forEach((e)=>{
                  e.classList.remove('error');
                });
                var errorMessageReset = document.querySelectorAll('.errorMessage');
                errorMessageReset.forEach((e)=>{
                  e.innerText = "";
                });
                if(checkFirstName.error){
                  document.querySelector(".errorFirstName_"+idx).innerText = checkFirstName.error_message;
                  updateShippingFirstName.classList.add('error');
                } 
                if(checkLastName.error){
                  document.querySelector(".errorLastName_"+idx).innerText = checkLastName.error_message;
                  updateShippingLastName.classList.add('error');
                }
                if(checkFirstNameKana.error){
                  document.querySelector(".errorFirstNameKana_"+idx).innerText = checkFirstNameKana.error_message;
                  updateShippingFirstNameKana.classList.add('error');
                }
                if(checkLastNameKana.error){
                  document.querySelector(".errorLastNameKana_"+idx).innerText = checkLastNameKana.error_message;
                  updateShippingLastNameKana.classList.add('error');
                }
                if(checkPhone.error){
                  document.querySelector(".errorPhoneNumber_"+idx).innerText = checkPhone.error_message;
                  updateShippingPhone.classList.add('error');
                }
                if(checkZip.error){
                  document.querySelector(".errorzipCode_"+idx).innerText = checkZip.error_message;
                  updateShippingZip.classList.add('error');
                }
                if(checkAddressCity.error){
                  document.querySelector(".errorRegisterAddressCity_"+idx).innerText = checkAddressCity.error_message;
                  updateShippingCity.classList.add('error');
                } 
                if(checkAddress1.error){
                  document.querySelector(".errorRegisterAddress1_"+idx).innerText = checkAddress1.error_message;
                  updateShippingAddress1.classList.add('error');
                }
                if(checkAddress2.error){
                  document.querySelector(".errorRegisterAddress2_"+idx).innerText = checkAddress2.error_message;
                  updateShippingAddress2.classList.add('error');
                }
              }
            }
          }
        });
      });
    }
    /***************************************************************/
    // デフォルトに設定する
    async function shippingAddressDefaultAction(getAccountFullAddress,getAddress){
      // var getAccountFullAddress = await getFullAddress(c_id);
      // var getAddress = await getAccountAddress(c_id);
      
      var UpdateShippingAddresses = document.querySelectorAll('.setDefaultAddress');
      UpdateShippingAddresses.forEach(function(e){
        e.addEventListener('click',async function(){
          document.querySelector("#loading").classList.add("active");
          var formId = e.dataset.addressId;
		  var idx = e.dataset.id;
          for(i=0;i<getAccountFullAddress.addresses.length;i++){
            if(getAccountFullAddress.addresses[i].seq == 1){
              getAccountFullAddress.addresses[i].seq = getAccountFullAddress.addresses.length + 1;
              getAccountFullAddress.addresses.concat(getAccountFullAddress.addresses[i]);
            }
          }
          
          for(i=0;i<getAccountFullAddress.addresses.length;i++){
            if(getAccountFullAddress.addresses[i].seq == Number(e.dataset.seq)){
              getAccountFullAddress.addresses[i].seq = 1;
            }
          }

          for(i=0;i<getAccountFullAddress.addresses.length;i++){
            if(getAccountFullAddress.addresses[i].seq == getAccountFullAddress.addresses.length + 1){
              getAccountFullAddress.addresses[i].seq = Number(e.dataset.seq);
            }
          }
          getAccountFullAddress.addresses.sort(function(a,b){
            if(a.seq < b.seq) return -1;
            if(a.seq > b.seq) return 1;
            return 0;
          });
          var array = {
            "addresses": getAccountFullAddress.addresses
          }
			var firstName = getAccountFullAddress.addresses[0].first_name
          var lastName = getAccountFullAddress.addresses[0].last_name
          var firstNameKana = getAccountFullAddress.addresses[0].first_name_kana
          var lastNameKana = getAccountFullAddress.addresses[0].last_name_kana
          var phone = getAccountFullAddress.addresses[0].phone
          var zipcode = getAccountFullAddress.addresses[0].zip
          var prefecture = getAccountFullAddress.addresses[0].prefecture
          var city = getAccountFullAddress.addresses[0].city
          var address1 = getAccountFullAddress.addresses[0].address1
          var address2 = getAccountFullAddress.addresses[0].address2
          var mail_magazine_flg = getAddress.mail_magazine_flg
          var result = await updateAddress(c_id, firstName, lastName, firstNameKana, lastNameKana, phone, zipcode, prefecture, city, address1, address2, mail_magazine_flg)

          
          if(result.message == "success."){
            await updateFullAddress(c_id, array);
            // location.reload(true);
            console.log(idx);
            document.querySelector('#address_default_address_' + idx).checked = true;
            document.querySelector('#form_default_data_' + idx).click();
            // location.href = "?account_update=true";
          } else {
				document.querySelector("#loading").classList.remove("active");
            var result = "";
            document.querySelector("#loading").classList.remove("active");
            document.querySelector("#errorText").innerText = "";
            document.querySelector("#errorTextWrap").style.display = "flex";
            document.querySelector("#errorText").innerHTML = "正常に更新されませんでした。<br>お手数お掛けいたしますが、ページを更新し再度お確かめください";
            document.querySelector("#errorReload").style.display = 'block';
          }
          
        });
      });
    }
    /***************************************************************/
    /**
     * 会員住所削除
     */
    async function ShippingAddressRemove(getAccountFullAddress){
      // var getAccountFullAddress = await getFullAddress(c_id);
      var deleteBtns = document.querySelectorAll('.addressDelete');
      var addressId = "";
      deleteBtns.forEach(function(e){
        e.addEventListener('click',async function(elm){
document.querySelector("#loading").classList.add("active");
          // getAccountFullAddress.
          for(i=0;i<getAccountFullAddress.addresses.length;i++){
            if(getAccountFullAddress.addresses[i].seq == Number(e.dataset.seq)){
              getAccountFullAddress.addresses.splice(i, 1);
            }
          }
          addressId = e.dataset.addressId;
          var deleteTarget = document.querySelector("#EditAddressList_" + addressId);
          deleteTarget.remove();
          var array = {
            "addresses": getAccountFullAddress.addresses
          }
          var result = await updateFullAddress(c_id, array);
          if(result.message == "success."){
            // location.reload(true);
            location.href = "?account_update=true";
          } else {
            document.querySelector("#loading").classList.remove("active");
          }
        });
      });
    }
    /***************************************************************/
    async function fn_delivery_action(){
      var getAccountFullAddress = await getFullAddress(c_id);
      var getAddress = await getAccountAddress(c_id);
      getFullAddressAction(getAccountFullAddress);
      shippingAddressDefaultAction(getAccountFullAddress,getAddress);
      ShippingAddressRemove(getAccountFullAddress);
      ShippingAddress(getAccountFullAddress);
    }
    /***************************************************************/
    /**
     * パスワード更新
     * pages/update-password
     */
    function passwordUpdate(){
      var customerInfoPasswordChange = document.querySelector("#customerInfoPasswordChange");
      var updateOldPassword = document.querySelector("#updateOldPassword");
      var updateNewPassword = document.querySelector("#updateNewPassword");
      var updateNewPasswordCheck = document.querySelector("#updateNewPasswordCheck");
      var Complete = document.querySelector("#Complete");
      var queries = location.search;
      if(queries.match(/update=true/)){
        document.querySelector("#Complete").style.display = "block";
          document.querySelector("#Complete").innerHTML = "パスワードの変更が完了いたしました。";
        } else {
          document.querySelector("#Complete").style.display = "none";
        }
      customerInfoPasswordChange.addEventListener('click',async function(){
        
        var passwordSome = false;
        var passWordOldCheck = await varidationPassword(updateOldPassword.value);
        var passWordCheck = await varidationPassword(updateNewPassword.value);
        if(updateNewPassword.value != updateNewPasswordCheck.value){
          passwordSome = {
            error: true,
            error_message: "新しいパスワードと同じパスワードを入力してください"
          };
        }else {
          passwordSome = {
            error: false
          };
        }
        if(updateNewPassword.value == updateOldPassword.value){
          passwordNoChange = {
            error: true,
            error_message: "古いパスワードと新しいパスワードが同じです。違うパスワードを入力してください。"
          };
        }else {
          passwordNoChange = {
            error: false
          };
        }
        var errorReset = document.querySelectorAll('.error');
          errorReset.forEach((e)=>{
            e.classList.remove('error');
          });
          var errorMessageReset = document.querySelectorAll('.errorMessage');
          errorMessageReset.forEach((e)=>{
            e.innerText = "";
          });
        if(!passWordOldCheck.error && !passWordCheck.error && !passwordSome.error && !passwordNoChange.error){
          document.querySelector("#loading").classList.add("active");
          var result = await updatePasswd(c_id, updateOldPassword.value, updateNewPassword.value);
          if(result.message == "success."){
            var redirectURL = location.href;
            location.href = redirectURL + "?update=true";
          } else {
            document.querySelector("#loading").classList.remove("active");
          }
  
        } else {
          
          if(passWordOldCheck.error){
            document.querySelector(".errorupdateOldPassword").innerText = "パスワードを確認してください";
            updateOldPassword.classList.add('error');
          } 
          if(passWordCheck.error){
            document.querySelector(".errorupdateNewPassword").innerText = "パスワードは半角英字の小文字、半角英字の大文字、半角数字の3つを組み合わせて8文字以上、20文字以内で入力してください";
            updateNewPassword.classList.add('error');
          } 
          if(passwordSome.error){
            document.querySelector(".errorupdateNewPasswordCheck").innerText = "新しいパスワードと同じパスワードを入力してください";
            updateNewPasswordCheck.classList.add('error');
          }
          if(passwordNoChange.error && !passWordCheck.error){
            document.querySelector(".errorupdateNewPassword").innerText = passwordNoChange.error_message;
            updateNewPassword.classList.add('error');
          }
        }
        
      });
    }
    /***************************************************************/
    /**
     * メールアドレス更新
     * pages/update-mailaddress
     */
    function mailUpdateAction(){
      var customerInfoMailChangeContent = document.querySelector("#customerInfoMailChangeContent");
      var customerInfoMailChange = document.querySelector("#customerInfoMailChange");
      var updateOldMail = document.querySelector("#updateOldMail");
      var updateNewMail = document.querySelector("#updateNewMail");
      var updateNewMailCheck = document.querySelector("#updateNewMailCheck");
      var updateOldMailChecker = document.querySelector("#updateOldMailChecker");
      var mailUpdate = document.querySelector("#mailUpdate");
      var queries = location.search;
      if(queries.match(/update=true/)){
        document.querySelector("#Complete").style.display = "block";
        document.querySelector("#Complete").innerHTML = `<span style="font-weight: bold">メールアドレスの変更が完了いたしました。</span><br>
        <span style="font-size: 12px; color: #EA0606">※メールアドレス変更の反映にはお時間がかかる場合がございます。<br>
        このあと何通かは変更前のメールアドレスにメールマガジンが配信される場合がございます。<br>
        あらかじめご了承くださいませ。</span>`;
      } else {
        document.querySelector("#Complete").style.display = "none";
      }
      customerInfoMailChange.addEventListener('click',async function(){
        var checkOldEmail = await validationEmail(updateOldMail.value);
        var checkNewEmail = await validationEmail(updateNewMail.value);
        var checkMailSome = false;
        var checkMailOldSome = false;
        if(updateNewMail.value != updateNewMailCheck.value){
          checkMailSome = {
            error: true,
            error_message: "新しいメールアドレスと同じメールアドレスを入力してください"
          }
        } else {
          checkMailSome = true;
        }
        if(updateOldMail.value != updateOldMailChecker.value){
          checkMailOldSome = {
            error: true,
            error_message: "現在設定されているメールアドレスを入力してください"
          }
        } else {
          checkMailOldSome = true;
        }
        var errorReset = document.querySelectorAll('.error');
          errorReset.forEach((e)=>{
            e.classList.remove('error');
          });
          var errorMessageReset = document.querySelectorAll('.errorMessage');
          errorMessageReset.forEach((e)=>{
            e.innerText = "";
          });
        if(!checkOldEmail.error && !checkNewEmail.error && !checkMailSome.error && !checkMailOldSome.error){
          document.querySelector("#loading").classList.add("active");
          var result = await updateEmailAddress(c_id, updateOldMail.value, updateNewMail.value);
          if(result.message == "success."){
            localStorage.setItem('upemail',updateNewMail.value);
            location.href = "/pages/mail-authcode";
          } else {
            document.querySelector("#loading").classList.remove("active");
          }
        } else {
          
          
          if(checkOldEmail.error){
            document.querySelector(".errorupdateOldMail").innerText = checkOldEmail.error_message;
            updateOldMail.classList.add('error');
          } 

          if(checkMailOldSome.error){
            document.querySelector(".errorupdateOldMail").innerText = checkMailOldSome.error_message;
            updateOldMail.classList.add('error');
          }
          
          if(checkNewEmail.error){
            document.querySelector(".errorupdateNewMail").innerText = checkNewEmail.error_message;
            updateNewMail.classList.add('error');
          } 
          if(checkMailSome.error){
            document.querySelector(".errorupdateNewMailCheck").innerText = checkMailSome.error_message;
            updateNewMailCheck.classList.add('error');
          } 
        }
      });
    }
    /***************************************************************/
    /**
    * マイページトップ
    * 
    * 
    */
    async function myAccountPageAction(c_id){
      var getAccount = await getAccountAddress(c_id);
      if(getAccount.message == "success."){
        document.querySelector("#loading").classList.remove("active");
      }
      let array = ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県'];
    }
    /***************************************************************/
    /**
    * 退会
    */
    function withdrawalAction(){
      const accountWithdrawalBtn = document.querySelector("#accountWithdrawal");
      const accountWithdrawalSubmitBtn = document.querySelector("#accountWithdrawalSubmitBtn");
      accountWithdrawalBtn.addEventListener('click',async function(){
       var WithdrawalCheck = confirm('退会すると同じメールアドレス・お電話番号では再度会員登録することはできません。退会しますか？');
        if(WithdrawalCheck){
          document.querySelector("#loading").classList.add("active");
        var result = await deleteCustomer(c_id);
         var result = true
          if(result){
            accountWithdrawalSubmitBtn.click();
          }
        }
      });
    }
    /***************************************************************/
    /**
    * パスワードの再設定
    */
    function resetPasswordAction() {
      var recoverPasswordBtn = document.querySelector('#recoverPasswordBtn');
      var RecoverEmail = document.querySelector('#RecoverEmail');
      var RecoverLastName = document.querySelector('#RecoverLastName');
      var RecoverFirstName = document.querySelector('#RecoverFirstName');
      
      recoverPasswordBtn.addEventListener('click', async function(){
        //パスワードの形式チェック
        var RecoverEmailCheck = validationEmail(RecoverEmail.value);
        var RecoverLastNameCheck = varidationName(RecoverLastName.value);
        var RecoverFirstNameCheck = varidationName(RecoverFirstName.value);
        if(!RecoverEmailCheck.error && !RecoverLastNameCheck.error && !RecoverFirstNameCheck.error){
          document.querySelector("#loading").classList.add("active");
          var result = await resetPassword(RecoverEmail.value, RecoverLastName.value, RecoverFirstName.value);
          if(result.message == "success."){
            localStorage.setItem('reset_email', RecoverEmail.value);
            localStorage.setItem('security_cd', result.security_cd);
            localStorage.setItem('system_datetime', result.system_datetime);
            location.href = "/pages/password-reset-authcode";
          }
        } else {
          var errorReset = document.querySelectorAll('.error');
          errorReset.forEach((e)=>{
            e.classList.remove('error');
          });
          var errorMessageReset = document.querySelectorAll('.errorMessage');
          errorMessageReset.forEach((e)=>{
            e.innerText = "";
          });
          if(RecoverEmailCheck.error){
            document.querySelector(".errorRecoverPassEmail").innerText = RecoverEmailCheck.error_message;
            RecoverEmail.classList.add('error');
          } 
          if(RecoverLastNameCheck.error){
            document.querySelector(".errorRecoverLastName").innerText = RecoverLastNameCheck.error_message;
            RecoverLastName.classList.add('error');
          } 
          if(RecoverFirstNameCheck.error){
            document.querySelector(".errorRecoverFirstName").innerText = RecoverFirstNameCheck.error_message;
            RecoverFirstName.classList.add('error');
          } 
        }
      });
    }
    /***************************************************************/
    /**
     * パスワードの再設定の認証
     */
    function passwordUpdateAction() {
      var resetBtn = document.querySelector('#ResetPasswordBtn');
      var resetMail = document.querySelector('#ResetPassword-email');
      var resetAuthcode = document.querySelector('#ResetPassword-authcode');
      var resetNewpassword = document.querySelector('#ResetPassword-newpassword');
      var resetNewpasswordSome = document.querySelector('#ResetPassword-newpassword_some');
      var resetSecurityCd = document.querySelector('#ResetPassword-security_cd');
      var resetSystemDatetime = document.querySelector('#ResetPassword-system_datetime');
      resetMail.value = localStorage.getItem('reset_email');
      resetSecurityCd.value = localStorage.getItem('security_cd');
      resetSystemDatetime.value = localStorage.getItem('system_datetime');

      resetBtn.addEventListener('click',async function(){
        var passSome = true;
        if(resetNewpassword.value != resetNewpasswordSome.value){
          passSome = {
            error: true,
            error_message: "新しいパスワードと確認のパスワードは同じものを入力してください"
          }
        }
        var resetAuthcodeCheck = validationAuthcode(resetAuthcode.value);
        var resetNewpasswordCheck = varidationPassword(resetNewpassword.value);
        var errorReset = document.querySelectorAll('.error');
          errorReset.forEach((e)=>{
            e.classList.remove('error');
          });
          var errorMessageReset = document.querySelectorAll('.errorMessage');
          errorMessageReset.forEach((e)=>{
            e.innerText = "";
          });
        if(!resetAuthcodeCheck.error && !resetNewpasswordCheck.error && !passSome.error){
          document.querySelector("#loading").classList.add("active");
          var result = await authenticatePassword(resetMail.value, resetAuthcode.value, resetNewpassword.value, resetSecurityCd.value, resetSystemDatetime.value);
          if(result.message == "success."){
            localStorage.removeItem('reset_email');
            localStorage.removeItem('security_cd');
            localStorage.removeItem('system_datetime');
            location.href = "/account/login?reset=true";
          }
        } else {
          
          if(resetAuthcodeCheck.error){
            document.querySelector(".errorResetPassAuthcode").innerText = resetAuthcodeCheck.error_message;
            resetAuthcode.classList.add('error');
          } 
          if(resetNewpasswordCheck.error){
            document.querySelector(".errorResetPassNewPass").innerText = resetNewpasswordCheck.error_message;
            resetNewpassword.classList.add('error');
          } 
          if(passSome.error){
            document.querySelector(".errorResetPassNewSomePass").innerText = passSome.error_message;
            resetNewpasswordSome.classList.add('error');
          } 
        }
        
      });
    }
    /***************************************************************/
    /**
    * メルマガ確認用
    */
    async function mailmgazinAction(){
document.querySelector("#loading").classList.add("active");
      var getAccount = await getAccountAddress(c_id);
      var queries = location.search;
      if(queries.match(/success=true/)){
        document.querySelector("#Complete").style.display = "block";
        if(getAccount.mail_magazine_flg == "0"){
          document.querySelector("#Complete").innerHTML = "メルマガ購読をONにしました";
        } else {
          document.querySelector("#Complete").innerHTML = "メルマガ購読を解除しました";
        }
      } else {
        document.querySelector("#Complete").style.display = "none";
      }
      var mailMagazinSwitch = document.querySelector('#switch1');
      if(getAccount.mail_magazine_flg == "0"){
        mailMagazinSwitch.checked = true;
      }
document.querySelector("#loading").classList.remove("active");
      mailMagazinSwitch.addEventListener('change',async function(e){
document.querySelector("#loading").classList.add("active");
        var mailmagazinCheck = "";
        if(mailMagazinSwitch.checked){
          mailmagazinCheck = "0";
        } else {
          mailmagazinCheck = "1";
        }
        var result = await updateAddress(c_id, getAccount.first_name, getAccount.last_name, getAccount.first_name_kana, getAccount.last_name_kana, getAccount.phone, getAccount.zip, getAccount.prefecture, getAccount.city, getAccount.address1, getAccount.address2, mailmagazinCheck);
        if(result.message == "success."){
          location.href = "/pages/mail-magazin?success=true";
        } else {
          document.querySelector("#loading").classList.remove("active");
        }
      });
    }
    /***************************************************************/
    // 子ども新規追加
    
    function babyNew(){
      
      var babyLastName = document.querySelector("#babyLastName");
      var babyFirstName = document.querySelector("#babyFirstName");
      var babyLastNameKana = document.querySelector("#babyLastNameKana");
      var babyFirstNameKana = document.querySelector("#babyirstNameKana");
      var babySex = document.querySelector("#babySex");
      var babyBirthday = document.querySelector("#babyBirthday");
      var NewBabyBtn = document.querySelector('#NewBabyAdd');
      var babyRelation = document.querySelector('#babyRelation');
      
      NewBabyBtn.addEventListener('click',async function(){
        document.querySelector("#loading").classList.add("active");
        var getChild = await fnGetChildrenInfo(c_id);
        var newBaby = [{
          seq: Number(NewBabyBtn.dataset.length) + 1,
          last_name: "ベイビー",
          first_name: "ベイビー",
          last_name_kana: "ベイビー",
          first_name_kana: "ベイビー",
          birthday: babyBirthday.value,
          born_flg: "0",
          sex: babySex.value,
          relationship: babyRelation.value
        }];
        var params = getChild.children.concat(newBaby);
        for(i=0;i<params.length;i++){
          var d = params[i].birthday;
          params[i].birthday = d.slice(0, 10);
        }
        var baby = {
          children: params
        }
        var result = await fnUpdateChildrenInfo(c_id, baby);
          if(result.message == "success."){
            location.href = "/pages/children-info?success=true";
          } else {
            document.querySelector("#loading").classList.remove("active");
          }
      });
    }
    /***************************************************************/
    // 子ども新規追加
    
    function childrenNew(){

      var childrenLastName = document.querySelector("#childrenLastName");
      var childrenFirstName = document.querySelector("#childrenFirstName");
      var childrenLastNameKana = document.querySelector("#childrenLastNameKana");
      var childrenFirstNameKana = document.querySelector("#childrenFirstNameKana");
      var childrenSex = document.querySelector("#childrenSex");
      var childrenRelation = document.querySelector("#childrenRelation");
      var childrenBirthday = document.querySelector("#childrenBirthday");
      var NewChildrenBtn = document.querySelector('#NewChildren');
      
      
      NewChildrenBtn.addEventListener('click',async function(){
        var errorReset = document.querySelectorAll('.error');
          errorReset.forEach((e)=>{
            e.classList.remove('error');
          });
          var errorMessageReset = document.querySelectorAll('.errorMessage');
          errorMessageReset.forEach((e)=>{
            e.innerText = "";
          });
        var last_nameCheck = await varidationName(childrenLastName.value);
        var first_nameCheck = await varidationName(childrenFirstName.value);
        var last_name_kanaCheck = await varidationKanaName(childrenLastNameKana.value);
        var first_name_kanaCheck = await varidationKanaName(childrenFirstNameKana.value);
        if(!last_nameCheck.error && !first_nameCheck.error && !last_name_kanaCheck.error && !first_name_kanaCheck.error){
          document.querySelector("#loading").classList.add("active");
          var getChild = await fnGetChildrenInfo(c_id);
          var params = [{
              seq: Number(NewChildrenBtn.dataset.length) + 1,
              last_name: childrenLastName.value,
              first_name: childrenFirstName.value,
              last_name_kana: childrenLastNameKana.value,
              first_name_kana: childrenFirstNameKana.value,
              sex: childrenSex.value,
              born_flg: "1",
              birthday: childrenBirthday.value,
              relationship: childrenRelation.value
            }];
            params = getChild.children.concat(params);

            for(i=0;i<params.length;i++){
              var d = params[i].birthday;
              params[i].birthday = d.slice(0, 10);
            }
            
            
          var child = {
            children: params
          }
          var result = await fnUpdateChildrenInfo(c_id, child);
          if(result.message == "success."){
            location.href = "/pages/children-info?success=true";
          } else {
            document.querySelector("#loading").classList.remove("active");
          }
        } else {
          if(last_nameCheck.error){
            document.querySelector(".errorChildrenLastName").innerText = last_nameCheck.error_message;
            childrenLastName.classList.add('error');
          } 
          if(first_nameCheck.error){
            document.querySelector(".errorChildrenFirstName").innerText = first_nameCheck.error_message;
            childrenFirstName.classList.add('error');
          } 
          if(last_name_kanaCheck.error){
            document.querySelector(".errorChildrenLastNameKana").innerText = last_name_kanaCheck.error_message;
            childrenLastNameKana.classList.add('error');
          } 
          if(first_name_kanaCheck.error){
            document.querySelector(".errorChildrenFirstNameKana").innerText = first_name_kanaCheck.error_message;
            first_name_kanaCheck.classList.add('error');
          }
        }
        
      });
    }
    /***************************************************************/
    /**
     * 子ども情報更新用
     */
    function updateChildren(){
      $('.UpdateChildrenInfo').on('click',async function(){
        var errorReset = document.querySelectorAll('.error');
          errorReset.forEach((e)=>{
            e.classList.remove('error');
          });
          var errorMessageReset = document.querySelectorAll('.errorMessage');
          errorMessageReset.forEach((e)=>{
            e.innerText = "";
          });
        var id = $(this).data('form-id');
        var last_name = $('#ChildrenLastName_' + id);
        var first_name = $('#ChildrenFirstName_' + id);
        var last_name_kana = $('#ChildrenLastNameKana_' + id);
        var first_name_kana = $('#ChildrenFirstNameKana_' + id);
        var sex = $('#childrenSex_' + id);
        var relation = $('#childrenRelation_' + id);
        var birthday = $('#ChildrenBirthday_' + id);
        var born_flg = $('#born_flg_' + id);
        var last_nameCheck = await varidationName(last_name.val());
        var first_nameCheck = await varidationName(first_name.val());
        var last_name_kanaCheck = await varidationKanaName(last_name_kana.val());
        var first_name_kanaCheck = await varidationKanaName(first_name_kana.val());
        if($(born_flg).prop("checked")){
          var born = "1";
        } else {
          var born = "0";
        }
        var birthday_set = "";
        if(born == "0"){
          birthday_set = "-01";
        }
        if(!last_nameCheck.error && !first_nameCheck.error && !last_name_kanaCheck.error && !first_name_kanaCheck.error){
          document.querySelector("#loading").classList.add("active");
          var getChild = await fnGetChildrenInfo(c_id);
          for(i=0;i<getChild.children.length;i++){
            var d = getChild.children[i].birthday;
            getChild.children[i].birthday = d.slice(0, 10);
            if(getChild.children[i].seq == Number(id)){
              getChild.children[i].last_name = last_name.val();
              getChild.children[i].first_name = first_name.val();
              getChild.children[i].last_name_kana = last_name_kana.val();
              getChild.children[i].first_name_kana = first_name_kana.val();
              getChild.children[i].sex = sex.val();
              getChild.children[i].birthday = birthday.val();
              getChild.children[i].born_flg = born;
              getChild.children[i].relationship = relation.val();
            }
          }
          var child = {
            children: getChild.children
          }
          var result = await fnUpdateChildrenInfo(c_id, child);
          if(result.message == "success."){
            location.href = "/pages/children-info?success=true";
          } else {
            document.querySelector("#loading").classList.remove("active");
          }
        } else {
          if(last_nameCheck.error){
            document.querySelector(".errorLastName_"+id).innerText = last_nameCheck.error_message;
            last_name.addClass('error');
          } 
          if(first_nameCheck.error){
            document.querySelector(".errorFirstName_"+id).innerText = first_nameCheck.error_message;
            first_name.addClass('error');
          } 
          if(last_name_kanaCheck.error){
            document.querySelector(".errorLastNameKana_"+id).innerText = last_name_kanaCheck.error_message;
            last_name_kana.addClass('error');
          } 
          if(first_name_kanaCheck.error){
            document.querySelector(".errorFirstNameKana_"+id).innerText = first_name_kanaCheck.error_message;
            first_name_kana.addClass('error');
          }
        }
        
      });
    }
     

    
    /***************************************************************/
    // 子ども削除
    childrenRemove();
    function childrenRemove(){
      $('.childrenDelete').on('click',async function(){
        $("#loading").addClass("active");
        var getChild = await fnGetChildrenInfo(c_id);
        var id = $(this).data('seq');
        for(i=0;i<getChild.children.length;i++){
          if(getChild.children[i].seq == Number(id)){
            getChild.children.splice(i,1);
          }
        }
        for(i=0;i<getChild.children.length;i++){
          var d = getChild.children[i].birthday;
          getChild.children[i].birthday = d.slice(0, 10);
          getChild.children[i].seq = i + 1;
        }
        var child = {
          children: getChild.children
        }
        var result = await fnUpdateChildrenInfo(c_id, child);
          if(result.message == "success."){
            location.href = "/pages/children-info?success=true";
          } else {
            document.querySelector("#loading").classList.remove("active");
          }
      });
    }
    /***************************************************************/
    
    function childrenDefault(){
      $('.setDefaultChildren').on('click',async function(){
        $("#loading").addClass("active");
        var getChild = await fnGetChildrenInfo(c_id);
        var id = $(this).data('seq');
        
        for(i=0;i<getChild.children.length;i++){
          var d = getChild.children[i].birthday;
          getChild.children[i].birthday = d.slice(0, 10);
          if(getChild.children[i].seq > 1 && getChild.children[i].seq == id){
            getChild.children[i].seq = 1;
          }
        }
        getChild.children[0].seq = id;
        getChild.children.sort(function(a,b){
          if(a.seq < b.seq) return -1;
          if(a.seq > b.seq) return 1;
          return 0;
        });
        var child = {
          children: getChild.children
        }
        var result = await fnUpdateChildrenInfo(c_id, child);
          if(result.message == "success."){
            location.href = "/pages/children-info?success=true";
          } else {
            document.querySelector("#loading").classList.remove("active");
          }
      });
    }
    /***************************************************************/
    /**
    * メールアドレスと確認用の照合用
    * @param customerEmailCheck
    * @param customerEmail
    */
    function emailValidation(customerEmailCheck, customerEmail) {
      var v = customerEmailCheck.value;
      var mailResult = checkEmail(v, customerEmail);
      if (!mailResult) {
        customerEmailCheck.style.borderColor = "red";
        customerEmailCheck.classList.add("error");
      } else {
        customerEmail.style.borderColor = "#cccccc";
        customerEmail.classList.remove("error");
        customerEmailCheck.style.borderColor = "#cccccc";
        customerEmailCheck.classList.remove("error");
      }
    };
    /***************************************************************/
    /**
    * メールアドレスと確認用の照合
    * @param email
    * @param customerEmail
    */
    function checkCollationEmail(email, customerEmail) {
      if (email != customerEmail) {
        console.error('メールアドレスが違います');
        return false;
      } else {
        return true;
      }
    }
    /***************************************************************/
    /**
    * メールアドレスの形式チェック
    * @param email
    * @param customerEmail
    */
    function validationEmail(eMailAddress) {
      var errorMessage = [];
      const vali = eMailAddress.match(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/);
      if (!vali) {
        errorMessage = {
          error: true,
          error_message: "誤ったメールアドレスで入力されています"
        }
        return errorMessage;
      } else {
        return true;
      }
    }
    /***************************************************************/
    /**
     * 郵便番号バリデーション
     * @param zipCoadFormat 
     * @returns 
     */
    function validationZipcode(zipCoadFormat) {
      var errorMessage = [];
      const vali = zipCoadFormat.match(/^\d{3}-\d{4}$/);
      if (!vali) {
        errorMessage = {
          error: true,
          error_message: "ハイフンありの有効な郵便番号を入力してください"
        }
        return errorMessage;
      } else {
        return true;
      }
    }
    /***************************************************************/
    /**
     * パスワードのバリデーション
     * @param passWordLength 
     * @returns 
     */
    function varidationPassword(passWordLength) {
      var errorMessage = [];
      const passWordMatch = passWordLength.match(/^(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z])[a-zA-Z0-9]{8,20}$/);
      if (!passWordMatch) {
        errorMessage = {
          error: true,
          error_message: "パスワードは半角英字の小文字、半角英字の大文字、半角数字の3つを組み合わせて8文字以上、20文字以内で入力してください"
        }
        return errorMessage;
      } else {
        return true;
      }
    }
    /***************************************************************/
    /**
     * 電話番号バリデーション
     * @param phoneNumber 
     * @returns 
     */
    function validationPhone(phoneNumber) {
      const vali = phoneNumber.match(/^\d{2,4}\d{1,4}\d{1,4}$/);
      var errorMessage = [];
      if( phoneNumber.length < 10 ){
        errorMessage = {
          error: true,
          error_message: "市外局番を入れた番号で入力してください"
        }
        return errorMessage
      }

      if (!vali) {
        errorMessage = {
          error: true,
          error_message: "半角数字+ハイフンなしで入力してください"
        }
        return errorMessage;
      } else {
        return true;
      }
    }
    /***************************************************************/
    /**
     * 認証コードバリデーション
     * @param authcode 
     * @returns 
     */
     function validationAuthcode(authcode) {
      const vali = authcode.match(/^\d{6}$/);
      var errorMessage = [];
      if (!vali) {
        errorMessage = {
          error: true,
          error_message: "認証コードが違うようです。メールをお確かめの上再度入力してください"
        }
        return errorMessage;
      } else {
        return true;
      }
    }
    /***************************************************************/
    /**
     * 住所の長さ判定
     * @param cityLength 
     * @returns 
     */
      String.prototype.bytes = function () {
        var length = 0;
        for (var i = 0; i < this.length; i++) {
          var c = this.charCodeAt(i);
          if ((c >= 0x0 && c < 0x81) || (c === 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
            length += 1;
          } else {
            length += 2;
          }
        }
        return length;
      };
    async function validationCity(cityLength,required = false) {
      const vali = cityLength.bytes();
      var errorMessage = [];
      if(required && vali === 0){
        errorMessage = {
          error: true,
          error_message: "必須項目です。入力をしてください。"
        }
        return errorMessage;
      } else if (vali > 32) {
          errorMessage = {
            error: true,
            error_message: "16文字以内で入力してください"
          }
          return errorMessage;
        } else {
          errorMessage = {
            error: false
          }
          return errorMessage;
        } 
    }
    /***************************************************************/
    // 氏名
    function varidationName(text,address = false){
      //記号
      var kigou = "ー―‐";
      //数字
      var suji = "";
      //ローマ字
      var romaji = "ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ";
      //ひらがな
      var hiragana = "ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん";
      //カタカナ
      var katakana = "ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ";
      //ギリシャ
      var girisya = "ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρστυφχψω";
      //キリル
      var kiriru = "АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдеёжзийклмнопрстуфхцчшщъыьэюя";
      //罫線
      var keisen = "";
      //JIS 第一水準 漢字　髙﨑
      var kanjiStandard1 = "髙﨑々亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕";
      //JIS 第二水準 漢字
      var kanjiStandard2 = "弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙";
      //全角全て
      var zenkaku = kigou + suji + romaji + hiragana + katakana + girisya + kiriru + keisen + kanjiStandard1 + kanjiStandard2;
      var errorMessage = [];
      if(!address){
        if(text.length == 0){
          errorMessage = {
            error: true,
            error_message: "入力されていません。"
          }
          return errorMessage;
        } else if (text.length > 20) {
          errorMessage = {
            error: true,
            error_message: "20文字以内で入力してください"
          }
          return errorMessage;
        }
      }
      
      for(var i = 0, len = text.length; i < len; i++){
          //1つでも全角でなかったらfalse
          if(isZenkakuChar(text.substr(i, 1)) == false || text.length == 0){
            errorMessage = {
              error: true,
              error_message: "使用できない文字が含まれています。"
            }
              return errorMessage;
          } else {
            errorMessage = {
              error: false
            }
          }
      }
      function isZenkakuChar(char){
        if(char === null || char == "" || char.length > 1){
            throw new Error("char's length must be 1");
        }
        return zenkaku.indexOf(char) >= 0;
      }
      return true;
    }
    
    /***************************************************************/
    // カナ
    function varidationKanaName(text){
      
      //カタカナ
      var katakana = "ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ";
      var kigou = "ー―‐";
      //全角全て
      var zenkaku =  katakana+kigou;
      var errorMessage = [];
      if(text.length == 0){
        errorMessage = {
          error: true,
          error_message: "入力されていません。"
        }
        return errorMessage;
      } else if (text.length > 20) {
        errorMessage = {
          error: true,
          error_message: "20文字以内で入力してください"
        }
        return errorMessage;
      }
      for(var i = 0, len = text.length; i < len; i++){
          //1つでも全角でなかったらfalse
          if(isZenkakuChar(text.substr(i, 1)) == false){
            errorMessage = {
              error: true,
              error_message: "全角カナで入力してください"
            }
              return errorMessage;
          } else {
            errorMessage = {
              error: false
            }
          }
      }
      function isZenkakuChar(char){
        if(char === null || char == "" || char.length > 1){
            throw new Error("char's length must be 1");
        }
        return zenkaku.indexOf(char) >= 0;
      }
      return true;
    }
    /***************************************************************/
    function varidationMessage(checkFirstName,checkLastName,checkFirstNameKana,checkLastNameKana,checkPhone,checkZip,checkAddressCity,checkAddress1,checkAddress2){
      if(checkFirstName.error){
        document.querySelector(".errorName").innerText = checkFirstName.error_message;
        updateCustomerFirstName.classList.add('error');
      } 
      if(checkLastName.error){
        document.querySelector(".errorName").innerText = checkLastName.error_message;
        updateCustomerLastName.classList.add('error');
      }
      if(checkFirstNameKana.error){
        document.querySelector(".errorNameKana").innerText = checkFirstNameKana.error_message;
        updateCustomerFirstNameKana.classList.add('error');
      }
      if(checkLastNameKana.error){
        document.querySelector(".errorNameKana").innerText = checkLastNameKana.error_message;
        updateCustomerLastNameKana.classList.add('error');
      }
      if(checkPhone.error){
        document.querySelector(".errorPhoneNumber").innerText = checkPhone.error_message;
        updateCustomerPhone.classList.add('error');
      }
      if(checkZip.error){
        document.querySelector(".errorzipCode").innerText = checkZip.error_message;
        updateCustomerZip.classList.add('error');
      }
      if(checkAddressCity.error){
        document.querySelector(".errorAddressCity").innerText = checkAddressCity.error_message;
        updateCustomerCity.classList.add('error');
      } 
      if(checkAddress1.error){
        document.querySelector(".errorAddress1").innerText = checkAddress1.error_message;
        updateCustomerAddress1.classList.add('error');
      }
      if(checkAddress2.error){
        document.querySelector(".errorAddress2").innerText = checkAddress2.error_message;
        updateCustomerAddress2.classList.add('error');
      }
    }
    /***************************************************************/
  
    /**
    * ページごとの関数呼び出し
    */
    setTimeout(function(){
    let customerPages = location.href;
    if(customerPages.match(/account\/login/)){
      var queries = location.search;
      if(queries.match(/register=true/)){
        document.querySelector("#Complete").style.display = "block";
        document.querySelector("#Complete").innerHTML = "会員登録ありがとうございました。<br>下記のフォームよりログインしてください";
      } else if(queries.match(/reset=true/)){
        document.querySelector("#Complete").style.display = "block";
        document.querySelector("#Complete").innerHTML = "パスワードのリセットが完了しました。";
      }
      loginAction();
      resetPasswordAction();
    } else if(customerPages.match(/account\/register/)) {
      registerCustomerAction();    
    } else if(customerPages.match(/account\/address/)){
      fn_delivery_action();
    } else if(customerPages.match(/pages\/update-password/)){
      passwordUpdate();
    } else if(customerPages.match(/pages\/update-mailaddress/)){
      mailUpdateAction();
    } else if(customerPages.match(/pages\/account-withdrawal/)){
  if(location.search.match(/contact_posted=true/)){
        // location.href = "/account/logout/"
      }
      withdrawalAction();
    } else if(customerPages.match(/pages\/mail-authcode/)){
      registerCustomerAuthenticateAction();
    } else if(customerPages.match(/pages\/account-register/)){
      // 会員情報登録ページ
      registerCustomerAddressAction();
    } else if(customerPages.match(/pages\/account-info/)){
      // 会員情報登録ページ
      getAddressAction(c_id);
    } else if(customerPages.match(/pages\/mail-magazin/)){
      // メルマガ
      mailmgazinAction();
    } else if(customerPages.match(/pages\/password-reset-authcode/)){
      // パスワード更新
      passwordUpdateAction();
    } else if(customerPages.match(/pages\/children-info/)){
      //子ども情報
		babyNew();
      childrenNew();
      updateChildren();
      childrenRemove();
      childrenDefault();
      $('.children-edit-toggle').on('click',function(){
        var id = $(this).data('form-id');
        $('#EditChildren_'+id).toggleClass('hide');
      });
      var childrenNewButton = document.querySelector('#ChildrenNew');
      childrenNewButton.addEventListener('click',function(){
        ChildrenNewForm.classList.toggle('hide');
      });
    } else if(customerPages.match(/account/)){
      myAccountPageAction(c_id);
      
    }
    
    },200);
    var logoutBtn = document.querySelector('#customer_logout_link');
	var logoutBtnSp = document.querySelector('#customer_logout_link_sp');
    if(logoutBtn){
      logoutBtn.addEventListener('click',function(){
        document.querySelector("#loading").classList.add("active");
        customerLogout(c_id);
      });
    }

if(logoutBtnSp){
      logoutBtnSp.addEventListener('click',function(e){
        document.querySelector("#loading").classList.add("active");
        customerLogout(c_id);
      });
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-cancel"]) return;
  try {
    
/**
   * API接続ステージング
   * @param path 
   * @param params 
   * @param method 
   * @param redirect 
   */
  function apiController(path, params = "", method, redirect = false, cookies = false){
    return new Promise((resolve, reject) => {
      // default
      var headers = {
        "method": method,
        "credentials": "include",
        "mode": "cors",
        "headers": {
          "Content-Type": "application/json",
        }
      }
      // @Paramsがあるか判定
      if(params != ""){
        headers["body"] = JSON.stringify(params)
      }
      const base_url = "https://customapp.mikihouse.co.jp/prd/api/v1/frontend/orders";
      const url = base_url + path;
      // APIリクエスト
      fetch(url,headers).then(
        response => response.json()
      ).then((res) => {
        console.log(res);
        return resolve(res);
      }).catch((error) => {
        console.error(error);
        return reject('失敗！')
      });
    });
  }
  function orderCancelAction(){
   var orderCancelBtn =  document.querySelector("#orderCancel");
   orderCancelBtn.addEventListener('click', async function(){
    var cancel_check = confirm('本当にキャンセルしますか？\n出荷状況によってはキャンセルができません。');
    var params = {
      "order_number": orderCancel.dataset.orderNumber,
      "customer_id": orderCancel.dataset.customerId
    }
    var path = '/' + orderCancel.dataset.orderId + "/cancel";
    var method = "POST";
    if(cancel_check){
      document.querySelector("#loading").classList.add("active");
      var result = await apiController(path,params,method,false,false);
    if(result.message == "success." ){
      location.href = '?order_cancel=true';
    } else {
      var errMess = result.message.split('。');
      document.querySelector("#loading").classList.remove("active");
      document.querySelector("#errorText").innerText = "";
      document.querySelector("#errorTextWrap").style.display = "flex";
      document.querySelector("#errorText").innerHTML = errMess[0];
      document.querySelector("#errorClose").style.display = 'block';
    } 
    }
    
   });
  }
  orderCancelAction();

  } catch(e) { console.error(e); }
})();
})();
